const en = {
  translation: {
    common: {
      appName: "eServices",
      email: "Email Address",
      password: "Password",
      confirmPassword: "Confirm Password",
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      address: "Address",
      submit: "Submit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      back: "Back",
      search: "Rechercher...",
      loading: "Chargement...",
      actions: "Actions",
      date: "Date",
      amount: "Amount",
      status: "Status",
      total: "Total",
      quantity: "Quantity",
      price: "Price",
      product: "Product",
      see_details: "Details",
      download: "Download",
      copied: "Copied!",
      theme: "Theme",
      language: "Language",
      settings: "Settings",
      logout: "Logout",
      dashboard: "Dashboard",
      profile: "Profile",
      yes: "Yes",
      no: "No",
      optional: "Optional",
      quantity_decrease: "Decrease quantity",
      quantity_increase: "Increase quantity",
      currency: "TND",
      balance: "Balance",
      page: "page",
      next: "Next",
      prev: "Prev",
      read_all: "Mark all as read",
      reset: "Reset",
      filter: "Filter",
      confirm: "Confirm",
      error: "An error occurred",
      unknown_error: "Unknown error",
      unit: "unité",
      and: "et",
      favorites: "Favoris",
      login: "common.login",
      light_mode: "Mode clair",
      dark_mode: "Mode sombre",
      notifications: "Notifications",
      security: "Sécurité",
      close: "Fermer",
      open_full: "Ouvrir en plein écran",
      copy: "Copy",
      role: {
        admin: "Administrateur",
        client: "Client"
      }
    },
    ManageProducts: {
      header: {
        title: "Product Management"
      },
      form: {
        titleNew: "New Product",
        titleEdit: "Edit Product",
        name: "Product Name",
        description: "Description",
        descriptionPlaceholder: "Detailed product description...",
        price: "Base Price (TND)",
        category: "Category",
        subcategory: "Sub-category",
        status: "Status",
        statusOnSale: "On sale",
        statusIncoming: "Incoming",
        statusSoldOut: "Sold out",
        value: "Value",
        valuePlaceholder: "e.g. 1 GB, 5 TND...",
        minQuantity: "Minimum quantity",
        deliveryMethod: "Delivery method",
        deliveryMethods: {
          codeInstantane: "Instant code",
          mailCompteCode: "Email account + code",
          mailCode: "Email code",
          mailAcces: "Email access",
          mailLicence: "Email licence",
          traitementLien: "Link processing",
          livraisonDomicile: "Home delivery"
        },
        saleType: "Sale type",
        saleTypes: {
          detail: "Retail",
          gros: "Wholesale"
        },
        paymentMethods: "Payment methods",
        paymentMethodsLabels: {
          solde: "Balance",
          livraison: "Delivery",
          carte: "Card",
          virement: "Bank transfer",
          mandat: "Money order",
          portefeuille: "Wallet",
          p2p: "P2P"
        },
        validated: "Validated product",
        bestSeller: "Best seller",
        duplicateSuffix: "(Copy)",
        showPreview: "Preview product",
        hidePreview: "Hide preview",
        images: {
          logo: "1. Logo / Brand",
          main: "2. Main Image",
          gallery: "3. Other images (Gallery)"
        },
        preferences: {
          title: "Pricing Options",
          addGroup: "+ GROUP",
          groupPlaceholder: "e.g. Coverage type",
          optionPlaceholder: "e.g. Rigid",
          required: "Required",
          featuresLabel: "Included services (1 per line)",
          featuresPlaceholder: "Enter features...",
          addValue: "+ NEW VALUE",
          removeGroup: "Remove this preference group",
          removeOption: "Remove this option",
          removeCondition: "Remove this condition",
          conditions: {
            if: "IF",
            groupSelect: "Group...",
            valueSelect: "Value...",
            thenPrice: "THEN SURCHARGE =",
            featuresLabel: "Included services (if condition)",
            featuresPlaceholder: "Specific features...",
            add: "+ Pricing condition"
          }
        },
        submit: {
          processing: "PROCESSING...",
          update: "UPDATE",
          create: "SAVE PRODUCT"
        }
      },
      validation: {
        nameRequired: "Product name is required",
        priceRequired: "Price must be greater than 0",
        subcategoryRequired: "Sub-category is required",
        minQuantityInvalid: "Minimum quantity must be at least 1",
        preferenceLabelRequired: "Label of preference #{{index}} is required",
        preferenceOptionsRequired: "Preference \"{{label}}\" must have at least one option",
        optionNameRequired: "Name of option #{{optionIndex}} in \"{{label}}\" is required"
      },
      preview: {
        title: "Preview",
        preferences: "Customization",
        productNamePlaceholder: "Product name",
        valueLabel: "Value",
        selectPlaceholder: "Select...",
        inputPlaceholder: "Enter {{field}}",
        amountPlaceholder: "Amount",
        estimatedTotal: "Estimated total price",
        filePlaceholder: "File to upload"
      },
      filters: {
        searchLabel: "Search",
        searchPlaceholder: "Product name...",
        categoryLabel: "Category",
        subcategoryLabel: "Sub-category",
        all: "All"
      },
      list: {
        empty: "No product found",
        basePriceSuffix: "(base)",
        duplicate: "Duplicate",
        edit: "Edit",
        delete: "Delete"
      },
      messages: {
        confirmDelete: "Delete this product?"
      }
    },
    ManagePaymentMethods: {
      page_title: "Payment Methods",
      page_subtitle: "Configure the payment methods available to your customers.",
      credentials_title: "Payment Details",
      disabled_badge: "Disabled",
      scope_short_order: "Order",
      scope_short_deposit: "Deposit",
      scope_short_product: "Catalog",
      stats: {
        total: "Payment methods",
        types: "Types (families)",
        subtypes: "Sub-types",
        enabled: "Enabled",
        disabled: "Disabled"
      },
      filters: {
        search: "Search",
        search_placeholder: "Name, identifier, RIB, code...",
        family: "Family",
        status: "Status",
        usage: "Usage",
        all_families: "All families",
        all_statuses: "All statuses",
        all_usages: "All usages",
        enabled: "Enabled",
        disabled: "Disabled",
        usage_order: "Order",
        usage_deposit: "Deposit",
        usage_product: "Catalog",
        reset: "Reset",
        no_results: "No payment method matches the filters.",
        results: "{{count}} result(s)"
      },
      card: {
        sort: "Order",
        created: "Created"
      },
      form: {
        add_method: "Add Method",
        edit_title: "Edit Method",
        add_title: "New Method",
        family_label: "Family",
        method: "Method",
        used_for_label: "Used For",
        scope_order: "Order",
        scope_deposit: "Deposit",
        scope_product: "Catalog",
        sort_order: "Display Order",
        instructions: "Instructions",
        instructions_placeholder: "Instructions shown to the customer (optional).",
        enabled: "Active",
        error_method_code: "Invalid method code.",
        error_scope: "Select at least one scope.",
        error_identifier_portefeuille: "Phone number is required for walllets.",
        error_identifier_phone: "Invalid Tunisian mobile number.",
        error_identifier_rib_required: "RIB is required.",
        error_identifier_rib_format: "RIB must be 20 digits.",
        error_identifier_ccp_required: "CCP is required.",
        error_identifier_ccp_format: "CCP must be 10-16 digits.",
        error_provider: "Provider name is required.",
        error_scope_solde_deposit: "Internal balance cannot be used for deposits.",
        error_scope_livraison_deposit: "Cash on delivery cannot be used for deposits.",
        error_scope_livraison_product: "Cash on delivery cannot be used for catalog.",
        error_scope_p2p_order: "P2P cannot be used for orders.",
        error_scope_p2p_product: "P2P cannot be used for catalog.",
        scope_forbidden: "Not applicable",
        scope_solde_no_deposit: "Reserved for orders/catalog",
        scope_livraison_no_deposit: "Reserved for orders",
        scope_livraison_no_product: "Reserved for orders",
        scope_p2p_no_order: "Reserved for deposits",
        scope_p2p_no_product: "Reserved for deposits",
        hint_rib: "20 digits required for bank RIB",
        hint_ccp: "10 to 16 digits for postal CCP",
        hint_phone: "Tunisian mobile number (+216)",
        identifier_label_portefeuille: "Phone Number (TN Mobile)",
        identifier_label_virement: "RIB (20 digits)",
        identifier_label_virement_postal: "CCP / Postal Account",
        identifier_label_mandat: "CIN or Reference (optional)",
        identifier_label_optional: "Identifier (optional)",
        family_auto: "(detected automatically)",
        provider_name: "Provider Name",
        identifier: "Primary Identifier",
        iban_optional: "IBAN (optional)",
        account_holder_optional: "Account Holder (optional)",
        family: {
          title: "Family",
          solde: "Balance",
          livraison: "Delivery",
          portefeuille: "Wallet",
          virement: "Transfer",
          carte: "Card",
          mandat: "Mandate",
          p2p: "P2P"
        }
      },
      method: {
        solde_interne: "Internal Balance",
        livraison: "Cash on Delivery",
        portefeuille_flouci: "Flouci",
        portefeuille_d17: "D17",
        portefeuille_izi_pay: "IZI Pay",
        portefeuille_wafacash: "Wafacash",
        virement_bancaire: "Bank Transfer",
        virement_postal: "CCP / Post",
        carte_bancaire: "Bank Card",
        carte_postale: "Postal Card",
        mandat_minute: "Instant Mandate",
        mandat_normale: "Standard Mandate",
        mandat_bancaire: "Bank Mandate",
        p2p: "P2P"
      },
      actions: {
        edit: "Edit",
        duplicate: "Duplicate",
        delete: "Delete"
      },
      details: {
        identifier: "Identifier",
        iban: "IBAN",
        holder: "Holder"
      },
      messages: {
        load_error: "Error loading data.",
        update_success: "Method updated.",
        create_success: "Method created.",
        delete_success: "Method deleted.",
        delete_confirm: "Are you sure you want to delete this method?"
      }
    },
    ManageStock: {
      header: {
        title: "Stock management"
      },
      tabs: {
        instant: "📦 Instant Codes",
        manual: "🔧 Manual Digital",
        physical: "🚚 Physical Stock"
      },
      common: {
        show: "Show",
        hide: "Hide",
        loading: "Loading...",
        error: "An error occurred",
        success: "Success",
        all: "All",
        actions: "Actions",
        previous: "Previous",
        next: "Next",
        cancel: "Cancel",
        close: "Close",
        save: "Save",
        product: "Product",
        choose: "Choose",
        type: "Type",
        status: "Status",
        quantity: "Quantity",
        date: "Date",
        email: "Email address",
        customer: "Customer",
        noData: "No data"
      },
      status: {
        onSale: "On sale",
        soldOut: "Sold out",
        incoming: "Incoming"
      },
      sync: {
        button: "Sync statuses",
        nothingToUpdate: "Everything looks correct.",
        updated: "{{count}} products updated.",
        confirm: {
          title: "Sync statuses?",
          description: "This will scan products and update their status when needed.",
          confirm: "Continue"
        }
      },
      instant: {
        kpis: {
          total: "Total codes",
          available: "Available",
          sold: "Sold",
          expired: "Expired"
        },
        import: {
          title: "Import codes",
          subtitle: "Expected format: code;serial;date (DD/MM/YYYY).",
          parsing: "Parsing file…",
          noInstantProduct: "No instant product",
          instantOnlyHint: "Import is only available for CODE_INSTANTANE products.",
          fileLabel: "File (.csv / .txt)",
          fileSelected: "File selected.",
          submit: "Import",
          uploading: "Importing {{count}} codes…",
          success: "Success! {{count}} codes imported.",
          errors: {
            badFormat: "Line {{line}}: expected \"code;serial;date\".",
            badCode: "Line {{line}}: code must contain exactly 15 digits.",
            badSerial: "Line {{line}}: serial must match \"SN-XXXXXXXXXXXXX\" (13 digits).",
            badDate: "Line {{line}}: invalid date, expected DD/MM/YYYY.",
            more: "(+{{count}} more)",
            noCode: "No code found."
          }
        },
        table: {
          title: "Instant codes",
          subtitle: "Browse and manage instant codes.",
          filters: {
            product: "Product",
            status: "Status",
            search: "Search",
            searchPlaceholder: "Reference or serial…"
          },
          columns: {
            reference: "Reference",
            serial: "Serial",
            status: "Status",
            expiration: "Expiration date",
            buyer: "Buyer",
            soldAt: "Sold on"
          },
          actions: {
            viewBuyer: "View buyer",
            details: "View details",
            markExpired: "Mark as expired"
          },
          status: {
            available: "Available",
            sold: "Sold",
            used: "Used",
            expired: "Expired"
          },
          pagination: {
            range: "{{from}} to {{to}} of {{total}} codes",
            page: "Page {{page}} / {{pages}}"
          },
          confirmExpire: {
            title: "Mark as expired?",
            description: "Status will be set to EXPIRED. This action cannot be undone.",
            confirm: "Mark expired"
          },
          toastExpired: "Code marked as expired."
        },
        details: {
          title: "Code details",
          codeEncrypted: "Code (hidden by default)",
          codeHash: "Hash",
          actions: {
            copyReference: "Copy reference"
          },
          otp: {
            hint: "To reveal the code, WhatsApp OTP verification is required.",
            grantedFor: "Reveal granted for {{seconds}} s.",
            phoneRequired: "A WhatsApp phone number is required to reveal the code (check your profile).",
            transactionLabel: "code reveal",
            success: "OTP verified. Reveal granted for ~{{minutes}} min."
          }
        },
        buyer: {
          title: "Buyer",
          openProfile: "Open customer profile"
        }
      },
      manual: {
        title: "Manual Digital",
        subtitle: "Toggle manual products availability.",
        actions: {
          setSoldOut: "Set to sold out",
          setOnSale: "Set to on sale"
        }
      },
      physical: {
        title: "Physical Stock",
        typeLabel: "Physical",
        actions: {
          history: "History",
          adjust: "Adjust"
        },
        adjust: {
          title: "Stock adjustment",
          movementType: "Movement type",
          in: "+ In",
          out: "- Out",
          reason: "Reason",
          reasonPlaceholder: "e.g. damage, inventory, return…",
          toastSuccess: "Stock adjusted successfully."
        }
      }
    },
    SplashScreen: {
      tagline: {
        slogan: "Your digital space"
      },
      status: {
        checking: "Checking for updates...",
        applying: "Applying update...",
        loading: "Loading resources..."
      },
      footer: {
        buildLabel: "Build"
      },
      logo: {
        appName: "eServices"
      }
    },
    favorites: {
      title: "Your Favorites",
      empty:
        "You don't have any favorites yet. Browse the catalog and save products you like.",
      remove: "Remove from favorites",
      view_all: "View all favorites",
      load_error:
        "We couldn't load your favorites. Check your internet connection, then try again.",
      retry: "Refresh list"
    },
    AIChatAssistant: {
      header: {
        title: "eServices AI",
        statusOnline: "Online",
        resetConversation: "Reset conversation"
      },
      emptyState: {
        title: "Need help?",
        description: "Ask me your questions about top-ups or our services."
      },
      input: {
        placeholder: "Your message..."
      },
      tooltip: {
        help: "Need help?"
      },
      messages: {
        errorTechnical: "Sorry, I'm having a small technical issue.",
        errorUnavailable: "Service temporarily unavailable.",
        errorQuota: "Assistant usage limit reached. Please try again in a few minutes."
      }
    },
    status: {
      en_attente: "Pending",
      pending: "Pending",
      validated: "Validated",
      refused: "Refused",
      validé: "Validated",
      refusé: "Refused",
      in_delivery: "In Progress",
      completed: "Completed",
      cancelled: "Cancelled",
      dispute: "Dispute",
      processing: "Processing",
      delivered: "Delivered",
      failed: "Failed",
      refunded: "Refunded",
      en_vente: "On Sale",
      en_arrivage: "Incoming",
      ouvert: "Open",
      en_cours: "In Progress",
      actif: "Active",
      suspendu: "Suspended",
      en_attente_email: "Pending email",
      awaiting_delivery: "Ready to Ship",
      p2p: "Transfer to identifier (deposit)",
      postal: "Postal Order",
      flouci: "Flouci",
      d17: "D17",
      izi_pay: "IZI Pay",
      virement: "Bank Transfer",
      épuisé: "Sold out"
    },
    notifications: {
      filter_by_type: "Filter by type",
      filter_all: "All",
      filter_orders: "Orders",
      filter_tickets: "Tickets",
      filter_deposits: "Deposits",
      filter_admin: "Clients",
      filter_alerts: "Alerts",
      empty_filtered: "No notifications in this category.",
      empty: "No notifications at the moment.",
      order_status_changed: "Your order #{{orderId}} status is now: {{status}}",
      replacement_order_created: "A replacement order (#{{replacementId}}) has been created for your order #{{originalId}}. New codes are available in My Codes.",
      deposit_validated: "Your deposit of {{amount}} has been validated.",
      deposit_refused: "Your deposit of {{amount}} has been refused.",
      ticket_reply: "New reply on your ticket #{{ticketId}}",
      admin: {
        new_order: "New order #{{orderId}} received ({{amount}})",
        new_deposit: "New deposit of {{amount}} received via {{method}}",
        new_ticket: "New support ticket: {{sujet}}",
        new_client: "New client registered: {{name}}",
        new_client_unknown: "New client"
      },
      generic: {
        default: "New notification",
        ticket_reponse: "New reply on a support ticket",
        ticket_statut: "Update on your support ticket status",
        ticket_cree: "Your ticket has been created",
        ticket_urgence: "Ticket marked as urgent",
        depot_valide: "Your deposit has been validated",
        depot_refuse: "Your deposit has been refused",
        depot_cree: "Your deposit has been recorded",
        commande_statut: "Your order status has been updated",
        commande_creee: "Your order has been created",
        commande_payee: "Your order has been paid",
        commande_livree: "Your order has been delivered",
        commande_annulee: "Your order has been cancelled",
        commande_litige: "Update regarding your order",
        nouveau_client: "New client registered",
        nouveau_ticket: "New support ticket",
        stock_faible: "Low stock alert",
        stock_epuise: "Out of stock",
        system_alert: "System alert"
      }
    },
    auth: {
      login: {
        title: "Welcome Back!",
        subtitle: "Log in to your client area",
        cta: "Sign In",
        forgot_password: "Forgot Password?",
        new_user: "New to Services?",
        create_account: "Create a Free Account",
        back_home: "Back Home",
        loading: "Connexion..."
      },
      register: {
        title: "Create an Account",
        subtitle: "Remplissez le formulaire ci-dessous pour commencer.",
        cta: "Create Account",
        have_account: "Already have an account?",
        login_link: "Sign in here",
        success_title: "Congratulations!",
        success_msg: "Votre compte a été créé avec succès. Un email de confirmation a été envoyé. Veuillez vérifier votre boîte email et cliquer sur le lien de confirmation. Pensez également à vérifier votre dossier de courrier indésirable (spam).",
        email_sent: "A confirmation email has been sent to",
        back_login: "Back to login"
      },
      errors: {
        invalid_credentials: "Email ou mot de passe incorrect.",
        user_not_found: "No account found with this email.",
        email_exists: "An account already exists with this email.",
        password_mismatch: "Passwords do not match.",
        email_not_confirmed: "Your account is not yet confirmed. Please check your inbox and click the confirmation link. Also check your spam folder.",
        generic: "Une erreur est survenue."
      }
    },
    Deposits: {
      paymentMethods: {
        p2p: "P2P",
        virement: "Bank Transfer",
        mandat: "Money Order",
        portefeuilles: "Wallets",
        carte: "Card",
        livraison: "Delivery"
      },
      mandatTypes: {
        minute: "Express Order",
        normale: "Standard Order",
        moneyGram: "MoneyGram"
      },
      p2p: {
        instructionsTitle: "P2P Instructions (Hand to hand)",
        instructionsDesc: "This method is a hand-to-hand delivery. Enter only your verification name below.",
        clientNameLabel: "Client name for verification",
        clientNamePlaceholder: "Your sender / delivery name"
      },
      mandat: {
        instructionsTitle: "Instructions for sending a Money Order",
        typeLabel: "Type of money order sent"
      }
    },
    Login: {
      sidebar: {
        appName: "eServices",
        heroDesc: "Your trusted partner for all your digital services.",
        securityBadge: "eServices Security",
        trustedLoginQuote: "Reliable sign-in, instant WhatsApp verification, and protected access for every session.",
        secureService: "Secure and reliable service",
        support24_7: "24/7 support available"
      },
      header: {
        title: "Welcome back!",
        subtitle: "Sign in to your client area"
      },
      form: {
        email: "Email address",
        password: "Password",
        emailPlaceholder: "example@email.com",
        passwordPlaceholder: "••••••••"
      },
      validation: {
        credentialsInvalid: "Email or password incorrect.",
        emailInvalid: "Invalid email format"
      },
      twoFA: {
        label: "Verification code (2FA)",
        hint: "Enter the 6-digit code from your authenticator app",
        placeholder: "000000",
        codeError: "Please enter a 6-digit code",
        invalidCode: "Invalid 2FA code",
        back: "← Back"
      },
      options: {
        rememberMe: "Stay signed in",
        forgotPassword: "Forgot password?"
      },
      captcha: {
        pleaseValidate: "Please complete the security CAPTCHA.",
        pleaseComplete: "Please complete the security verification",
        devMode: "🔧 Development mode: CAPTCHA disabled"
      },
      cta: {
        loading: "Signing in...",
        submit: "Sign in"
      },
      divider: {
        orContinueWith: "Or continue with"
      },
      oauth: {
        googleError: "Error signing in with Google",
        comingSoon: "Coming soon",
        googleLabel: "Google"
      },
      footer: {
        noAccount: "Don't have an account yet?",
        createAccount: "Create a free account",
        agreePrefix: "By signing in, you agree to our",
        termsLink: "Terms of use",
        and: "and our",
        privacyLink: "Privacy Policy"
      },
      whatsappOtp: {
        title: "WhatsApp verification",
        description:
          "A 6-digit code has been sent to your registered WhatsApp number.",
        cancelButton: "Cancel",
        submitButton: "Confirm code",
        verifying: "Verifying..."
      }
    },
    ResetPassword: {
      errors: {
        invalidOrExpiredLink: "Invalid or expired reset link. Please request a new link.",
        invalidLink: "Invalid reset link. Please request a new link.",
        verificationFailed: "Error while verifying the link. Please try again.",
        updateFailed: "Error while updating the password",
        resetFailed: "Error while resetting your password. Please try again."
      },
      validation: {
        passwordRequired: "Password is required",
        passwordMinLength: "Password must contain at least 6 characters",
        confirmPasswordRequired: "Password confirmation is required",
        passwordMismatch: "Passwords do not match"
      },
      loading: {
        verifyingLink: "Verifying link..."
      },
      invalidState: {
        title: "Invalid link",
        message: "This reset link is invalid or has expired. Please request a new link.",
        requestNewLink: "Request a new link"
      },
      sidebar: {
        appName: "eServices",
        heroDesc: "Set a new secure password",
        securePassword: "Secure password",
        bankEncryption: "Bank-level encryption"
      },
      header: {
        title: "New password",
        subtitle: "Enter your new secure password"
      },
      success: {
        title: "Password updated successfully!",
        description: "Redirecting to the login page in a few seconds..."
      },
      form: {
        newPasswordLabel: "New password",
        confirmPasswordLabel: "Confirm password",
        passwordPlaceholder: "••••••••",
        passwordHint: "Minimum 6 characters"
      },
      cta: {
        loading: "Updating...",
        submit: "Update password"
      },
      footer: {
        rememberPassword: "Remember your password?",
        loginLink: "Sign in"
      }
    },
    ForgotPassword: {
      validation: {
        emailRequired: "Email is required",
        emailInvalid: "Invalid email format"
      },
      errors: {
        sendFailed: "Error while sending the recovery email",
        sendRetry: "Error while sending the email. Please try again."
      },
      sidebar: {
        appName: "eServices",
        heroDesc: "Secure password recovery",
        secureRecoveryLink: "Secure recovery link",
        instantEmail: "Email sent instantly"
      },
      header: {
        title: "Forgot your password?",
        subtitle: "Enter your email address and we will send you a recovery link"
      },
      success: {
        title: "Email sent successfully!",
        description: "Check your inbox. A reset link has been sent to your email address. The link is valid for 1 hour.",
        backToLogin: "Back to login"
      },
      form: {
        emailPlaceholder: "example@email.com"
      },
      cta: {
        loading: "Sending...",
        submit: "Send recovery link"
      },
      footer: {
        rememberPassword: "Remember your password?",
        loginLink: "Sign in",
        needHelp: "If you have any issue, contact our",
        supportLink: "support"
      }
    },
    Register: {
      sidebar: {
        securityBadge: "Secure eServices onboarding",
        title: "Create your account",
        titleHighlight: "in less than 2 minutes.",
        description: "Encrypted workspace, smart verification, and fast activation of your customer profile.",
        testimonialQuote: "\"Ultra-smooth sign-up, instant verification, and a clear interface. You can feel the reliability right away.\"",
        testimonialAuthorInitials: "AT",
        testimonialAuthorName: "Amira T.",
        testimonialAuthorRole: "eCommerce Founder"
      },
      success: {
        title: "Congratulations!",
        message: "Your account has been created successfully. A confirmation email has been sent. Please check your inbox and click the confirmation link. Also check your spam folder.",
        backToLogin: "Back to login",
        phoneVerificationHint: "You can also verify your phone number via WhatsApp before signing in."
      },
      errors: {
        email_already_used: "This email address is already used by another account.",
        phone_already_used: "This phone number is already used by another account."
      },
      header: {
        title: "Create an account",
        subtitle: "Fill in the form below to get started."
      },
      form: {
        firstName: "First name",
        lastName: "Last name",
        email: "Email address",
        phone: "Phone",
        address: "Address",
        password: "Password",
        confirmPassword: "Confirm password",
        firstNamePlaceholder: "John",
        lastNamePlaceholder: "Doe",
        emailPlaceholder: "example@email.com",
        phonePlaceholder: "+216 21 380 039",
        phonePlaceholderDigits: "XXXXXXXX",
        phoneHelper: "Format: +216 XX XXX XXX",
        addressPlaceholder: "Street, City, Postal code",
        passwordPlaceholder: "••••••••"
      },
      validation: {
        firstNameRequired: "First name is required",
        firstNameMinLength: "First name must be at least 2 characters",
        lastNameRequired: "Last name is required",
        lastNameMinLength: "Last name must be at least 2 characters",
        emailRequired: "Email is required",
        emailInvalid: "Invalid email format",
        phoneRequired: "Phone is required",
        phoneInvalid: "Invalid phone format",
        phoneMinDigits: "Number must contain at least 8 digits",
        addressRequired: "Address is required",
        addressMinLength: "Address must be at least 5 characters",
        passwordRequired: "Password is required",
        passwordMinLength: "Password must be at least 6 characters",
        passwordRecommendLength: "For better security, use at least 8 characters",
        confirmPasswordRequired: "Please confirm your password",
        passwordMismatch: "Passwords do not match"
      },
      captcha: {
        pleaseValidate: "Please complete the security CAPTCHA.",
        pleaseComplete: "Please complete the security verification",
        devMode: "🔧 Development mode: CAPTCHA disabled"
      },
      cta: {
        loading: "Loading...",
        submit: "Create my account"
      },
      footer: {
        haveAccount: "Already have an account?",
        loginLink: "Sign in here",
        agreePrefix: "By creating an account, you agree to our",
        termsLink: "Terms of use",
        and: "and our",
        privacyLink: "Privacy Policy"
      }
    },
    LandingPage: {
      badges: {
        securePayment: "Secure payment",
        instantDelivery: "Instant delivery",
        support24_7: "24/7 support"
      },
      hero: {
        badge: "#1 Platform in Tunisia",
        title: "Your digital services",
        titleHighlight: "delivered in seconds",
        subtitle: "Gift cards, gaming codes, software licenses, streaming subscriptions... Buy securely and receive instantly by email. 100% automated, 24/7.",
        ctaPrimary: "Create a free account",
        ctaSecondary: "Explore our services",
        deliveryLabel: "Delivery",
        deliveryValue: "Instant ⚡"
      },
      favorites: {
        badge: "Your favorites",
        title: "Products you like",
        subtitle: "Discover your favorite products",
        scrollPrev: "Scroll favorites left",
        scrollNext: "Scroll favorites right"
      },
      categories: {
        badge: "Our services",
        title: "Popular categories",
        subtitle: "Hundreds of digital products available, delivered instantly to your inbox",
        gaming: { title: "Gaming Cards & Codes", desc: "PlayStation, Xbox, Steam, Nintendo, Free Fire, PUBG..." },
        giftCards: { title: "Gift Cards", desc: "Amazon, Google Play, App Store, Spotify, Netflix..." },
        mobile: { title: "Mobile Recharges", desc: "Ooredoo, Orange, Tunisie Telecom, internet plans..." },
        licenses: { title: "Licenses & Subscriptions", desc: "Windows, Office, Antivirus, VPN, Canva Pro, Adobe..." }
      },
      steps: {
        step1: { title: "Choose your product", desc: "Browse our catalog and select the digital service you need. Gaming codes, gift cards, licenses..." },
        step2: { title: "Pay securely", desc: "Pay by internal balance, D17 card or bank transfer. All transactions are secured and encrypted." },
        step3: { title: "Receive instantly", desc: "Your code or license is delivered automatically by email and in your account. No waiting, 24/7." }
      },
      howItWorks: {
        badge: "Simple & fast",
        title: "How does it work?",
        subtitle: "3 simple steps to receive your digital products in under a minute"
      },
      features: {
        badge: "Our advantages",
        title: "Why choose eServices?",
        subtitle: "A platform designed for your comfort, security and satisfaction",
        instant: { title: "Instant delivery", desc: "Receive your codes and licenses immediately after payment. 100% automated system, available 24/7." },
        secure: { title: "100% secure payments", desc: "SSL encrypted transactions, Cloudflare protection, and compliance with the strictest security standards." },
        variety: { title: "Wide range of services", desc: "Hundreds of products: gaming, streaming, software, gift cards, mobile recharges and much more." },
        automated: { title: "24/7 automated system", desc: "No human intervention required. Order anytime, receive instantly, even at night or on weekends." },
        support: { title: "Responsive customer support", desc: "A dedicated team to answer your questions via the ticket system, Facebook and Instagram." },
        pricing: { title: "Competitive prices", desc: "The best rates on the Tunisian market. No hidden fees, prices displayed in Tunisian Dinar (DT)." }
      },
      testimonials: {
        badge: "Verified reviews",
        title: "What our customers say",
        subtitle: "Join thousands of satisfied customers across Tunisia",
        reviewsCount: "Over 2000 positive reviews",
        roles: { gamer: "Passionate gamer", entrepreneur: "Entrepreneur", student: "Student" },
        reviews: {
          review1: "Amazing service! I received my PlayStation Store code in under 30 seconds. It's become my go-to for all my gaming purchases.",
          review2: "I use eServices for my professional licenses. Unbeatable prices and instant delivery. I recommend it to all my colleagues!",
          review3: "Perfect for Netflix and Spotify gift cards. Support is super responsive and the prices are the best I've found in Tunisia."
        }
      },
      security: {
        badge: "100% Secure",
        title: "Your security is our top priority",
        subtitle: "We use the most advanced technologies to protect your personal data and financial transactions.",
        encryption: { title: "256-bit SSL encryption", desc: "All your data and transactions are protected by bank-level encryption." },
        cloudflare: { title: "Cloudflare protection", desc: "Our platform is protected against DDoS attacks and web threats by Cloudflare." },
        supabase: { title: "Secure database", desc: "Supabase infrastructure with enhanced authentication and automatic backup." },
        automated: { title: "Hands-free delivery", desc: "Fully automated system. Your codes are generated and delivered without human handling." },
        uptime: "Guaranteed availability",
        ssl: "Advanced encryption"
      },
      cta: {
        badge: "100% free registration",
        title: "Ready to receive your digital services in seconds?",
        subtitle: "Join thousands of satisfied customers. Create your account in 30 seconds and enjoy instant delivery.",
        button: "Create my free account",
        trust: "✓ No commitment  ✓ No credit card required  ✓ Immediate access to all services"
      }
    },
    Profile: {
      appName: "eServices",
      header: {
        title: "My Profile"
      },
      subtitle: "eServices.tn client account",
      state: {
        loading: "Loading profile..."
      },
      success: {
        message: "Profile updated successfully!"
      },
      section: {
        title: "Personal Information",
        personal: "Personal information",
        contact: "Contact & security"
      },
      actions: {
        cancel: "Cancel",
        saving: "Saving...",
        save: "Save",
        edit: "Edit"
      },
      avatar: {
        change: "Change"
      },
      form: {
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phone: "Phone",
        address: "Address",
        phoneEmpty: "Not provided"
      },
      security: {
        note: "This information is used for sign-in, account recovery, and important notifications."
      },
      validation: {
        phoneInvalid: "Invalid phone format. Use +216 XX XXX XXX"
      }
    },
    ClientServices: {
      header: {
        title: "Services"
      },
      Categories: {
        section: {
          mobileTopups: "Top-ups and plans for all operators.",
          internationalPayments: "Buy from any international website and pay in Tunisian dinars.",
          customDocuments: "Customize your graphic, educational, and administrative documents.",
          subscriptions: "Streaming services, gaming, and more."
        }
      },
      SubCategories: {
        section: {
          graphicDesign: "Graphic design and visual creation services",
          tunisieTelecom: "Tunisie Telecom services and top-ups",
          internationalTransactions: "Payment solutions for international transactions",
          ooredooTunisie: "Ooredoo Tunisia services and top-ups",
          localTransactions: "Payment solutions for local transactions",
          orangeTunisie: "Orange Tunisia services and top-ups",
          streamingVideoMusic: "Video and music streaming services",
          gamingServices: "Video games and gaming services",
          appsAndSoftware: "Applications and software services",
          educationalResources: "Educational documents and resources",
          certificatesGeneration: "Certificate and attestation generation",
          administrativeDocuments: "Administrative document processing",
          secureOnlinePayments: "Secure online payment services",
          onlineCourses: "Online training and courses",
          productivityTools: "Tools to improve productivity"
        }
      },
      navigation: {
        back: "Back",
        allCategories: "All categories"
      },
      state: {
        loading: "Loading...",
        loadError: "Unable to load services.",
        emptyProducts: "No products found."
      }
    },
    CategoryCard: {
      content: {
        noDescription: "No description"
      }
    },
    MyCodes: {
      appName: "eServices",
      header: {
        title: "My Codes"
      },
      actions: {
        refreshTitle: "Refresh list"
      },
      alert: {
        deliveryPendingTitle: "Delivery pending",
        deliveryPendingMessage: "Some of your recent codes could not be delivered automatically due to a technical issue. Don't worry: our administrators have been notified and will assign your codes manually very soon after your order is validated.",
        checkOrders: "Check my orders",
        openTicket: "Open a support ticket"
      },
      sidebar: {
        history: "History"
      },
      state: {
        loading: "Loading..."
      },
      empty: {
        message: "No codes found."
      },
      badges: {
        code: "Code",
        licence: "Licence",
        compte: "Account",
        acces: "Access",
        lien: "Link"
      },
      fallback: {
        product: "Product"
      },
      security: {
        title: "Security guidelines",
        description: "This code is strictly confidential. Never share screenshots or the text of this code with third parties. For any technical issue, contact our customer support.",
        refLabel: "REF:",
        batchIdLabel: "BATCH ID:"
      },
      selectHint: {
        title: "Select a code from the list to see details.",
        description: "Please choose a code or access from the list to see the details."
      }
    },
    MobileManageOrders: {
      list: {
        title: "Orders",
        subtitle: "Manage your clients' orders",
        totalAmount: "Total amount",
        paymentMethod: "Payment method",
        itemsCount: "Items ({{count}})",
        moreItems_one: "+1 more item",
        moreItems_other: "+{{count}} more items",
        details: "Details",
        detailsA11y: "View order details"
      },
      empty: {
        title: "No orders",
        description: "No orders received."
      },
      modal: {
        orderTitle: "Order #{{id}}",
        close: "Close",
        client: "Client",
        deliveryPerProduct: "Delivery per product",
        accountEmail: "Username / Email",
        pAccountEmail: "email@example.com",
        password: "Password",
        invitationUrl: "Invitation URL / Email",
        licenceKey: "License key",
        certificateLink: "Certificate link (optional)",
        trackingLink: "Tracking link",
        pTracking: "Tracking number or link",
        clientNote: "Note to client",
        pNote: "e.g. In progress, Done...",
        code: "Code",
        pCode: "Code sent by email",
        assignedCodes: "Assigned codes",
        deliveryStatus: "Delivery status",
        inDelivery: "In delivery",
        delivered: "Delivered",
        payment: "Payment",
        status: "Status",
        items: "Items",
        total: "Total",
        unsavedConfirm: "Unsaved data. Close anyway?"
      },
      status: {
        instantCodesDone: "This order has already delivered instant codes. The 'Completed' status cannot be applied a second time."
      }
    },
    MobileTicketClients: {
      header: {
        title: "Clients with Tickets"
      },
      search: {
        placeholder: "Search by name or email..."
      },
      filters: {
        all: "All",
        active: "Active",
        inProgress: "In progress",
        closed: "Closed"
      },
      empty: {
        noClients: "No clients found",
        noResultsSearch: "No results for your search.",
        noResults: "No clients with tickets."
      },
      client: {
        activeCount: "active",
        lastActivity: "Last activity",
        totalTickets: "ticket(s)",
        closedCount: "closed",
        unknownEmail: "Unknown email",
        guestClient: "Guest client"
      }
    },
    MobileCheckout: {
      nav: {
        back: "Back"
      }
    },
    ClientCheckout: {
      appName: "eServices",
      header: {
        title: "Checkout"
      },
      summary: {
        title: "Order Summary",
        preview: "Summary",
        edit: "Edit",
        totalToPay: "Total to Pay",
        itemsCount: "{{count}} item(s)",
        delivery: "Delivery",
        stampFee: "Stamp fee",
        remise: "Discount",
        quantity: "Quantity",
        securePayment: "Tax incl. · Secure payment",
        estimateHomeDelivery: "Estimated delivery 2–4 days",
        estimateInstant: "Instant delivery",
        estimateDigital: "Digital delivery 1–24 h"
      },
      deliveryNotice: {
        instantTitle: "Instant delivery",
        instantMessage: "Your cart contains instant delivery items. All items in this order must be paid immediately using your internal balance.",
        homeTitle: "Home delivery",
        homeMessage: "Your order will be processed as soon as possible.",
        emailTitle: "Delivery",
        emailMessage: "Your codes and access information will be sent by email after your payment is validated."
      },
      deliveryInstructions: {
        code_instantane: "Instant Code",
        mail_compte_code: "Account + Code (Email)",
        mail_code: "Code (Email)",
        mail_acces: "Access (Email)",
        mail_licence: "License (Email)",
        traitement_lien: "Remote Processing",
        livraison_domicile: "Home Delivery",
        free: "Free"
      },
      payment: {
        title: "Payment Method"
      },
      selectSpecificMethod: "Please select a specific payment method",
      instructions: "Instructions",
      paymentMethods: {
        solde: "Balance",
        solde_interne: "Internal Balance",
        portefeuille: "Mobile wallet",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "Bank Transfer",
        carte: "Bank Card",
        mandat: "Money Order",
        livraison: "Cash on Delivery",
        p2p: "P2P"
      },
      alerts: {
        limitedMethods: "Note: Your cart contains instant delivery items. Only immediate payment methods are allowed for this order.",
        restrictedByProduct: "Some payment methods are not available for this type of product."
      },
      legal: {
        checkboxLabel: "I expressly accept the ",
        terms: "Terms and Conditions",
        privacy: "Privacy Policy",
        refund: "Refund Policy",
        delivery: "Delivery Policy",
        and: "and"
      },
      errors: {
        selectMethod: "Please select a payment method.",
        selectSpecificMethod: "Please select a specific payment method.",
        acceptTermsRequired: "Please accept the terms and conditions before continuing.",
        invalidInput: "Please check your payment details.",
        mandatNumberRequired: "Please enter the money order number of your transaction.",
        createError: "Error creating your order.",
        insufficientStock: "Insufficient stock for this product: requested {{requested}}, available {{available}}."
      },
      success: {
        title: "Order Confirmed!",
        message: "Your order has been placed successfully.",
        viewOrders: "View my orders"
      },
      solde: {
        current: "Current balance:",
        insufficient: "Insufficient balance. You need",
        missing: " more.",
        sufficient: "Sufficient balance.",
        processing: "Processing...",
        payBtn: "Pay with my Balance",
        cardIcon: "💳"
      },
      flouci: {
        instructionsTitle: "Instructions for FLOUCI",
        step1: "Send the amount to the account with the following number:",
        step2: "Enter the transaction reference:",
        refLabel: "Transaction reference (10 alphanumeric characters, uppercase)",
        refPlaceholder: "e.g. ABC123XYZ9",
        verifying: "Verifying...",
        confirmBtn: "Confirm payment",
        validationNote: "Validation within 10-30 minutes"
      },
      d17: {
        instructionsTitle: "Instructions for D17",
        step1: "Send the amount {{amount}} TND to the account with the following number:",
        step2: "Enter the authorization number:",
        authLabel: "Authorization number (6 digits)",
        authPlaceholder: "e.g. 123456",
        verifying: "Verifying...",
        confirmBtn: "Confirm payment"
      },
      izi_pay: {
        instructionsTitle: "Instructions for IZI Pay",
        step1: "Send {{amount}} TND to the IZI Pay identifier shown below:",
        step2: "Enter the code or transaction reference shown after payment:",
        authLabel: "Transaction code / reference (6 digits)",
        authPlaceholder: "e.g. 123456",
        verifying: "Verifying...",
        confirmBtn: "Confirm payment"
      },
portefeuille: {
        instructionsTitle: "Mobile wallet payment",
        step1: "Send {{amount}} to the identifier below (the exact app or service is shown on the seller's details).",
        step2: "Enter the reference or transaction code shown after payment.",
        refLabel: "Transaction reference / code",
        refPlaceholder: "e.g. ABC123XYZ9",
        verifying: "Verifying...",
        confirmBtn: "Confirm payment",
        validationNote: "Validation may take 10–30 minutes depending on the provider.",
        accountHolderSeparator: " — "
      },
       virement: {
         title: "Bank Transfer",
         bankAccounts: "Bank accounts",
         instructions: "Transfer {{amount}} to one of the accounts below.",
        rib: "RIB",
        iban: "IBAN",
        labelProof: "Upload transfer proof",
        chooseFile: "Choose file",
        fileTypes: "Images, PDF (MAX 5MB)",
        btnSending: "Sending...",
        btnSend: "Submit proof",
        missingAccountHolder: "Account holder not provided",
         accountHolder: "Account holder",
         proofLabel: "Payment proof (receipt)",
        bankIcon: "🏦"
      },
       selectHint: "Please select a payment method to continue",
       walletLogo: "Wallet",
       missingIdentifier: "Identifier not provided",
       termsAcceptance: "I have read and accept the terms and conditions and privacy policy.",
       confirmOrder: "Confirm order",
      config: {
        keyValue: "{{key}}: {{value}}"
      },
      disabled: {
        notAllowed: "Not allowed for this product",
        notConfigured: "Not configured",
        options: "option(s)"
      },
      livraison: {
        desc: "Pay in cash upon delivery of your order to your doorstep.",
        note: "A delivery fee may apply. You will be contacted to confirm the address and delivery slot.",
        processing: "Processing...",
        confirmBtn: "Order — Cash on Delivery"
      },
      carte: {
        desc: "Pay by bank card. You will receive payment instructions after order confirmation.",
        note: "Bank card payment details will be provided after your order is validated.",
        processing: "Processing...",
        confirmBtn: "Pay by Bank Card"
      },
      mandat: {
        instructionsTitle: "Money Order Payment",
        desc: "Send the amount via postal or bank money order (Standard Mandate, Mandat Minute Poste or MoneyGram) to one of the recipients below, then enter the money order number.",
        refLabel: "Money order number",
        refPlaceholder: "e.g. 123456789",
        numberHint: "Enter only the money order number (digits) — it allows our team to verify your transaction.",
        verifying: "Verifying...",
        confirmBtn: "Confirm payment",
        validationNote: "Validation takes 30–60 minutes depending on the provider."
      },
       p2p: {
         desc: "Direct person-to-person transfer. Contact us to get the recipient's details.",
         note: "This method requires prior contact with our team to arrange the transfer.",
         processing: "Processing...",
         confirmBtn: "Confirm P2P Transfer"
       }
    },
    NewOrder: {
      appName: "eServices",
      header: {
        title: "Place an Order"
      },
      browser: {
        back: "Back",
        categories: "Categories"
      },
      state: {
        loading: "Loading...",
        loadError: "Unable to load services."
      },
      cart: {
        title: "Your Order",
        empty: "Your cart is empty.",
        emptyHint: "Select a category to get started.",
        removeItem: "Remove",
        total: "Total"
      },
      errors: {
        selectMethod: "Please select a payment method.",
        proofRequired: "Please upload payment proof for this payment method.",
        insufficientBalance: "Insufficient balance. Please top up your account.",
        createError: "Error creating your order.",
        paymentConfig: "Payment configuration error. Please contact support."
      },
      success: {
        message: "Order placed successfully!"
      },
      payment: {
        label: "Payment Method",
        placeholder: "Choose a method...",
        proofLabel: "Payment proof (Required)",
        proofHint: "Please upload a screenshot or receipt to validate the transaction.",
        alertNote: "Note:",
        alertMessage: "Some items in your cart are \"Instant Code\" delivery. Only immediate payment methods are allowed for this order."
      },
      paymentMethods: {
        solde_interne: "Internal Balance",
        flouci: "Flouci",
        d17: "D17",
        virement: "Bank Transfer"
      },
      deliveryInstructions: {
        code_instantane: "Instant Code",
        mail_compte_code: "Account + Code (Email)",
        mail_code: "Code (Email)",
        mail_acces: "Access (Email)",
        mail_licence: "License (Email)",
        traitement_lien: "Remote Processing",
        livraison_domicile: "Home Delivery"
      },
      actions: {
        submitProcessing: "Sending...",
        submitConfirm: "Confirm Order"
      }
    },
    CartPage: {
      appName: "eServices",
      title: "Your Cart",
      itemSingular: "item",
      itemPlural: "items",
      inBasket: "in your basket",
      empty: {
        title: "Your cart is empty",
        description: "It looks like you haven't added any products to your cart yet.",
        browseServices: "Browse services"
      },
      alert: {
        instantMessage: "Your cart contains instant delivery products. All items in this order must be paid immediately via internal balance."
      },
      deliveryMethods: {
        code_instantane: "Instant code",
        mail_compte_code: "Account by email",
        mail_code: "Code by email",
        mail_acces: "Access by email",
        mail_licence: "License by email",
        traitement_lien: "Processing by link",
        livraison_domicile: "Home delivery"
      },
      deliveryInstructions: {
        code_instantane: "Instant Code",
        mail_compte_code: "Account + Code (Email)",
        mail_code: "Code (Email)",
        mail_acces: "Access (Email)",
        mail_licence: "License (Email)",
        traitement_lien: "Remote Processing",
        livraison_domicile: "Home Delivery"
      },
      groupCount: {
        article: "item",
        articles: "items"
      },
      summary: {
        title: "Order summary",
        subtotal: "Subtotal",
        deliveryFee: "Delivery fee",
        stampFee: "Stamp fee",
        total: "Total",
        ttc: "Inc. VAT",
        vatLabel: "VAT (19%):",
        vatNote: "For information only - Prices are already tax inclusive"
      },
      actions: {
        remove: "Remove",
        minRequired: "Minimum quantity of {{min}} required for this product type.",
        checkoutBtn: "Proceed to checkout",
        loginToCheckout: "Log in to checkout",
        continueShopping: "Continue shopping"
      },
      unit: "unit",
      securePayment: "Secure payment"
    },
    MobileDashboard: {
      appName: "eServices",
      banner: {
        welcome: "Welcome,",
        totalRevenue: "Total revenue",
        availableBalance: "Available balance"
      },
      miniStats: {
        today: "Today",
        deposits: "Deposits",
        totalOrders: "Total Orders",
        ticketsSupport: "Support Tickets",
        myOrders: "My Orders",
        myDeposits: "My Deposits"
      },
      adminStats: {
        pendingOrders: "Pending orders",
        pendingDeposits: "Pending deposits"
      },
      section: {
        seeAll: "See all",
        managementTitle: "Management & Administration",
        quickActionsTitle: "Quick Actions",
        popularProducts: "Popular Products",
        lastOrders: "Recent Orders",
        recentActivities: "Recent Activity",
        daySummary: "Daily Summary",
        newOrdersToday: "{{count}} new orders today."
      },
      quickActions: {
        orders: "Orders",
        deposits: "Deposits",
        tickets: "Tickets",
        clients: "Clients",
        products: "Products",
        stock: "Stock",
        categories: "Categories",
        media: "Media",
        recharge: "Top up",
        shop: "Shop",
        support: "Support",
        history: "History"
      },
      promotion: {
        limitedOffer: "Limited Offer",
        title: "Netflix Premium -20%",
        description: "Enjoy the best of streaming at a reduced price."
      },
      empty: {
        noRecentOrders: "No recent orders"
      },
      fallback: {
        product: "Product"
      },
      orderTitlePrefix: "Order #"
    },
    errors: {
      network: "Connection issue. Please check your internet access.",
      timeout: "Server taking too long to respond. Please try again.",
      auth: {
        invalid: "Incorrect email or password.",
        not_found: "No account found with this email.",
        unconfirmed: "Your account is not yet confirmed. Please check your email inbox and click on the confirmation link. Also remember to check your spam/junk folder.",
        exists: "Account already exists.",
        signup_failed: "Unable to create account. This email or phone number may already be in use. Please check your details or try again later.",
        too_short: "Password too short.",
        expired: "Session expired. Please log in again.",
        rate_limit: "Too many attempts. Please wait."
      },
      db: {
        duplicate: "This information already exists.",
        constraint: "Action impossible because item is linked.",
        denied: "Access denied."
      },
      storage: {
        not_found: "File not found on server.",
        too_large: "File is too large."
      }
    },
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      contact: "Contact",
      cart: "Cart",
      favorites: "Favorites",
      my_orders: "My Orders",
      my_deposits: "My Deposits",
      my_codes: "My Codes",
      my_tickets: "My Tickets",
      site_home: "Site Home",
      support: "Support",
      admin_panel: "Administration",
      search_order: "Search Order..."
    },
    dashboard: {
      welcome: "Welcome, {{name}}!",
      current_balance: "Current Balance",
      recent_deposits: "Recent Deposits",
      recent_orders: "Recent Orders",
      last_30_days: "Last 30 days",
      download_invoice: "Download invoice",
      no_data: "No data available",
      items_count: "{{count}} items",
      view_invoice: "Invoice",
      loading: "Chargement du tableau de bord...",
      available_balance: "Solde disponible"
    },
    Dashboard: {
      header: {
        appBadge: "Client Space",
        securityBadge: "Secure Vault",
        clientOverviewTitle: "{{name}} client overview",
        activeStatus: "Active account"
      },
      stats: {
        balance: "Available balance",
        deposits: "Recent deposits",
        orders: "Recent orders",
        pending: "Pending operations"
      },
      alerts: {
        lowBalance: "Warning: your balance is insufficient. Please make a deposit.",
        pendingOperations: "Alert: you have {{count}} pending operation(s)."
      },
      orders: {
        invoiceFileLabel: "PDF"
      }
    },
    landing: {
      hero_title: "All Your Digital Services",
      hero_subtitle: "in One Place",
      hero_desc: "Services devient votre plateforme complète pour acheter des services numériques et bien plus. Gérez toutes vos demandes facilement.",
      cta_start: "Get Started",
      cta_services: "Our Services",
      features: {
        fast: "Fast & Reliable",
        secure: "Secure Payments",
        support: "24/7 Support",
        operators: "All Carriers"
      },
      how_it_works: "How It Works?",
      steps: {
        1: "Create an Account",
        2: "Make a Deposit",
        3: "Place an Order"
      },
      testimonials: {
        1: {
        },
        2: {
        },
        3: {
        },
        4: {
        },
        5: {
        },
        title: "What Our Clients Say"
      },
      cta_footer: {
        title: "Ready to simplify your recharges?"
      },
      hero_image_alt: "eServices Illustration"
    },
    cart: {
      title: "Your Cart",
      empty_title: "Your cart is empty",
      empty_desc: "It looks like you haven",
      browse_services: "Browse Services",
      mode: "Mode:",
       remove: "Remove",
       pay: "Pay",
       min_required: "Quantité minimum de {{min}} requise pour ce type de produit.",
      summary_title: "Order Summary",
      subtotal: "Subtotal",
      total: "Total",
      checkout_btn: "Proceed to Checkout",
      login_to_checkout: "Login to Checkout",
      continue_shopping: "Continue Shopping",
      in_your_basket: "in your basket",
      extra_fees: "Service fees"
    },
    checkout: {
      title: "Checkout",
      summary_title: "Order Summary",
      edit: "Edit",
      total_to_pay: "Total to Pay",
      payment_method_title: "Payment Method",
      alerts: {
        limited_methods: "Note : Votre panier contient des articles à livraison instantanée. Seuls les paiements immédiats sont autorisés pour cette commande."
      },
      errors: {
        select_method: "Please select a payment method.",
        invalid_input: "Please check your payment details.",
        create_error: "Error creating your order.",
        insufficient_stock: "Insufficient stock for this product: requested {{requested}}, available {{available}}.",
        accept_terms_required: "Please accept the terms and conditions before continuing."
      },
      select_hint: "Please select a payment method to continue",
      view_orders: "View my orders",
      solde: {
        current: "Current Balance:",
        insufficient: "Solde insuffisant. Il vous manque",
        sufficient: "Solde suffisant.",
        processing: "Traitement...",
        pay_btn: "Pay with Balance"
      },
      flouci: {
        title: "Pay with Flouci",
        instructions: "Send payment to one of the following accounts:",
        step1: "1. Ouvrez l",
        no_account: "Aucun compte Flouci configuré.",
        label_id: "Your Transaction ID",
        placeholder_id: "ex: ABC123XYZ",
        btn_verifying: "Vérification...",
        btn_confirm: "Confirm Payment"
      },
      d17: {
        title: "Pay with D17",
        instructions: "Send payment to one of the following accounts:",
        step1: "1. Ouvrez l",
        no_account: "Aucun compte D17 configuré.",
        step2: "2. Saisissez le code de transaction reçu par SMS.",
        label_code: "Transaction Code (SMS)",
        placeholder_code: "ex: 12345678",
        btn_verifying: "Vérification...",
        btn_confirm: "Confirm Payment"
      },
      izi_pay: {
        title: "Pay with IZI Pay",
        instructions: "Send payment to the IZI Pay identifier shown.",
        step1: "1. Open the IZI Pay app and send {{amount}} to the identifier below.",
        no_account: "No IZI Pay account configured.",
        step2: "2. Enter the transaction code or reference.",
        label_code: "Transaction code / reference",
        placeholder_code: "e.g. 123456",
        btn_verifying: "Verifying...",
        btn_confirm: "Confirm payment"
      },
      portefeuille: {
        title: "Pay with mobile wallet",
        instructions: "Send the amount to the phone number or identifier below.",
        step1: "1. Open your operator’s app and send {{amount}} to the identifier below.",
        no_account: "No wallet account is configured for this deposit.",
        step2: "2. Enter the reference or transaction code provided after payment.",
        label_code: "Transaction reference / code",
        placeholder_code: "e.g. ABC123 or 123456",
        btn_verifying: "Verifying...",
        btn_confirm: "Confirm deposit"
      },
      virement: {
        title: "Bank Transfer",
        instructions: "Make a transfer of {{amount}} to one of the accounts below:",
        rib: "RIB:",
        iban: "IBAN:",
        holder: "Holder:",
        no_account: "Aucun compte bancaire configuré.",
        label_proof: "Upload Payment Proof",
        choose_file: "Choose File",
        file_selected: "File selected: {{name}}",
        no_file: "No file selected",
        btn_sending: "Envoi...",
        btn_send: "Submit Proof"
      },
      success: {
        title: "Order Confirmed!",
        message: "Votre commande a été passée avec succès."
      },
      legal: {
        checkbox_label: "I expressly accept the "
      }
    },
    transactionOTP: {
      title: "Confirm with code",
      subtitle: "The code will be sent to {{phone}}.",
      subtitleWithAmount: "Confirm your {{label}} of {{amount}} with the code that will be sent to {{phone}}.",
      sendCode: "Send code",
      sending: "Sending...",
      confirm: "Confirm",
      verifying: "Verifying...",
      resend: "Resend",
      cancel: "Cancel",
      expiresIn: "Expires in {{seconds}} s",
      errorExpired: "Code expired. Request a new code.",
      errorTooMany: "Too many attempts. Try again later.",
      errorInvalid: "Invalid code. Check and try again.",
      phoneRequired: "Add your phone number in your profile to confirm transactions."
    },
    TransactionOTPModal: {
      a11y: {
        close: "Close"
      },
      header: {
        title: "Confirm with a code",
        subtitle:
          "We'll send a 6-digit code to {{phone}} (by SMS or WhatsApp, depending on your setup).",
        subtitleWithAmount:
          "To confirm your {{label}} for {{amount}}, we'll send a 6-digit code to {{phone}}."
      },
      send: {
        sendCode: "Send code",
        sending: "Sending your code…",
        phoneInvalid:
          "We can't send a code: your number looks missing or incorrect. Check it in your profile."
      },
      testAccount: {
        a11yTitle: "Confirming transaction (test account)",
        loading: "Finishing your request…",
        error:
          "We couldn't complete this step. Use Try again or close this window.",
        retry: "Try again",
        close: "Close"
      },
      postVerify: {
        error:
          "Your code is correct, but the transaction didn't go through. Try again. If it keeps happening, contact support."
      },
      code: {
        expiresIn: "Code expires in {{seconds}} s",
        verifying: "Checking your code…",
        confirm: "Confirm",
        resend: "Resend code",
        resendWithCountdown: "{{label}} ({{seconds}}s)"
      },
      footer: {
        cancelDecorated: "─── Cancel ───"
      }
    },
    otpErrors: {
      send: {
        invalid_phone: "The phone number is invalid or missing. Check the format (e.g. 216 XXXXXXXX).",
        rate_limited: "Too many code requests. Wait a few minutes before requesting a new code.",
        api_error: "Unable to send the code at this time. Try again later or contact support.",
        ip_blocked: "Too many requests from your connection. Try again in 1 hour or later. If the problem persists, contact support.",
        network: "Connection problem. Check your internet and try again."
      },
      verify: {
        invalid_code: "The code you entered is incorrect. Check the 6 digits and try again.",
        expired: "This code has expired. Click « Resend » to receive a new code.",
        too_many_attempts: "The maximum number of attempts for this code has been reached. Please request a new code.",
        ip_blocked: "Too many requests from your connection. Try again in 1 hour or later.",
        network: "Connection problem. Check your internet and try again."
      },
      code_length: "The code must contain exactly 6 digits."
    },
    rateLimitingPolicy: {
      title: "Usage limits and security policy",
      subtitle: "Information on request limits and security measures applied on the platform.",
      lastUpdate: "Last update:",
      intro: "To protect the platform and all users from abuse (mass code sending, fraudulent sign-ups, etc.), we apply limits per IP address and per action. Below are the current policies.",
      tips: {
        sectionTitle: "For a smooth experience: how to avoid blocks",
        intro: "Following these simple rules will help you avoid any blocking or rate-limit messages.",
        tip1: "Enter the code you received (SMS/WhatsApp) within 10 minutes and carefully — maximum 5 attempts per code.",
        tip2: "Wait at least 10 minutes between two « New code » requests for the same number.",
        tip3: "Avoid doing many actions in a short time (order + deposit + resends); space them by a few minutes when possible.",
        tip4: "Use a stable connection (Wi‑Fi or 4G) to avoid unnecessary repeated attempts.",
        tip5: "If you see a block message, wait for the indicated time (e.g. 10 min, 1 hour, 24 h) or contact support if you believe it is an error."
      },
      otp: {
        sectionTitle: "1. Verification codes (OTP)",
        intro: "The 6-digit codes sent via WhatsApp (or SMS) for login, phone confirmation, and transaction validation (deposit, purchase) are subject to the following rules:",
        limit10m: "Limit of 5 sends per action type (login, deposit, order, admin) per 10-minute period.",
        limit10mBlock: "Each action type has its own quota; after 5 sends for the same action in 10 min, a 10-minute block applies for that action.",
        limitPerAction: "Counters are separate per action: login, deposit, order, and admin do not share the same 10-minute quota.",
        limitDay: "Daily limit of 20 sends per number over 24 hours (all actions combined).",
        limitDayBlock: "At 20 sends reached, automatic block for 24 hours.",
        oneCodeActive: "Only one active code at a time per number.",
        maxAttemptsPerCode: "Maximum 5 attempts per code.",
        maxAttemptsBlock: "After 5 incorrect attempts, the code becomes invalid and a new code must be requested.",
        blockVerify: "Exceeding 5 validation attempts: OTP code invalidated; request a new code.",
        codeValidity: "Code validity: 10 minutes after generation.",
        blockTitle: "If limits are exceeded:",
        block10m: "Exceeding 5 sends / 10 min for one action: 10-minute block for that action.",
        blockDay: "Exceeding 20 sends / 24 h: block for 24 hours.",
        blockExtreme: "Obvious abuse (very high number of requests): extended block possible."
      },
      register: {
        sectionTitle: "2. Registration (account creation)",
        intro: "Account creation attempts from the same connection are limited as follows:",
        limit1h: "Limit of 3 registrations maximum per hour.",
        limitDay: "Daily limit of 10 registrations per day.",
        blockTitle: "If limits are exceeded:",
        block1h: "1-hour block after 3 registrations in one hour.",
        block1hAfter: "After 3 registrations in one hour, 1-hour block.",
        blockDay: "At 10 registrations reached, block for 24 hours.",
        blockExtreme: "Obvious abuse: extended block possible.",
        waitTime: "Recommended wait: at least 20 minutes between each registration."
      },
      general: {
        sectionTitle: "3. General behaviour",
        byIp: "Limits are counted per individual IP address. The same Wi‑Fi or shared connection shares these limits.",
        noAccount: "Restrictions apply even without a user account: any request to the concerned services is counted.",
        contact: "If you are blocked while using the platform normally, contact support (contact@eservices.tn) and describe your situation.",
        tableNote: "The wait times indicated are recommendations to avoid automatic blocks; block durations are applied by the system."
      },
      table: {
        title: "Limits summary",
        action: "Action",
        limit: "Limit",
        waitTime: "Recommended wait time",
        blockDuration: "Block if exceeded",
        rowSendOtp: "OTP send",
        sendOtpLimit: "5 / 10 min (per action)",
        rowValidateOtp: "OTP validation",
        validateOtpLimit: "5 attempts per code",
        validateOtpWait: "Request a new code if attempts are exceeded",
        validateOtpBlock: "OTP code invalidated",
        rowDailyOtp: "Daily OTP sends",
        rowRegister: "Registration",
        rowDailyRegister: "Daily registrations",
        waitExpiration: "Wait for code expiration",
        spaceOut: "Space out sends",
        limitCreations: "Limit creations",
        rowIpBlock: "IP block (successive operations without waiting)",
        limitSuccessive: "Too many requests or actions in short time",
        waitBetweenActions: "A few minutes between each action",
        blockIpDuration: "1 h to 24 h (depending on case)"
      },
      footer: "These policies may be adjusted to improve security or user experience. The values above reflect the current configuration."
    },
    contact: {
      page_title: "Contact Us",
      page_subtitle: "Nous sommes là pour vous aider. Envoyez-nous un message et nous vous répondrons dès que possible.",
      info_emails_title: "Email Us",
      info_label_general: "General",
      info_label_support: "Support",
      info_label_sales: "Sales",
      info_phones_title: "Call Us",
      info_address_title: "Visit Us",
      form_title: "Send a Message",
      label_name: "Name",
      placeholder_name: "Your name",
      label_email: "Email",
      placeholder_email: "votre@email.com",
      label_phone: "Phone",
      placeholder_phone: "+216 21 380 039",
      label_subject: "Subject",
      subject_general: "General Inquiry",
      subject_support: "Technical Support",
      subject_sales: "Sales & Partnership",
      subject_other: "Other",
      label_message: "Message",
      placeholder_message: "How can we help you?",
      btn_sending: "Envoi...",
      btn_submit: "Send Message",
      footer_text: "Notre équipe est disponible 24/7 pour répondre à vos questions.",
      error_required: "Veuillez remplir tous les champs obligatoires.",
      ticket_subject: "{{theme}} - {{name}}",
      success_message: "Your message has been sent successfully!"
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Answers to all your questions about using Services.",
      question: "How to create an account?"
    },
    servicesPage: {
      hero: {
        titleFavorites: "Your Favorites",
        titleAll: "Discover Our Services",
        subtitleFavorites: "Find here all the products you've liked.",
        subtitleAll: "Solutions for all your digital and communication needs."
      },
      filters: {
        category: "Category",
        categoryAll: "All Categories",
        subcategory: "Sub-category",
        subcategoryAll: "All",
        availability: "Availability",
        availabilityAll: "All Statuses",
        saleType: "Sale Type",
        saleTypeAll: "All Types",
        saleTypeDetail: "Retail",
        saleTypeGros: "Wholesale",
        search: "Search",
        searchPlaceholder: "Name, value..."
      },
      state: {
        loading: "Loading..."
      },
      empty: {
        favorites: "You don't have any favorites.",
        search: "No products match your criteria."
      }
    },
    ServicesPage: {
      hero: {
        logo: "eServices",
        titleFavorites: "Your Favorites",
        titleAll: "Discover Our Services",
        subtitleFavorites: "Find here all the products you've liked.",
        subtitleAll: "Solutions for all your digital and communication needs."
      },
      filters: {
        category: "Category",
        categoryAll: "All Categories",
        subcategory: "Sub-category",
        subcategoryAll: "All",
        availability: "Availability",
        availabilityAll: "All Statuses",
        saleType: "Sale Type",
        saleTypeAll: "All Types",
        saleTypeDetail: "Retail",
        saleTypeGros: "Wholesale",
        search: "Search",
        searchPlaceholder: "Name, value..."
      },
      state: {
        loading: "Loading..."
      },
      empty: {
        favorites: "You don't have any favorites.",
        search: "No products match your criteria."
      }
    },
    product: {
      product: "Product",
      price_total: "Total Price",
      item: "article",
      items: "articles",
      delivery_method: "Delivery Method",
      similar_products: "Similar Products",
      adding: "Adding...",
      added: "Added",
      add_to_cart: "Add to Cart",
      unavailable: "Product unavailable",
      add: "Add",
      soon_available: "Coming Soon",
      out_of_stock: "Out of Stock",
      see_options: "See Options",
      badges: {
        wholesale: "Wholesale (Min {{min}})",
        sold_out: "Sold Out",
        incoming: "Incoming",
        best_seller: "Best Seller",
        soon: "Soon"
      },
      card: {
        decrease_qty: "Decrease quantity",
        increase_qty: "Increase quantity",
        remove_favorite: "Remove from favorites",
        add_favorite: "Add to favorites"
      },
      alerts: {
        min_qty: "La quantité minimale pour ce produit est de {{min}}.",
        required_field: "Please fill in the field: {{label}}",
        select_option: "Please select an option for: {{label}}",
        upload_login: "You must be logged in to upload files.",
        upload_error: "Upload failed for {{label}}.",
        add_error: "Error adding to cart.",
        rating_required: "Please provide a rating."
      },
      breadcrumb: {
        home: "Home",
        services: "Services",
        category: "Category"
      },
      preferences: {
        required: "(Required)",
        included_features: "Included Features:"
      },
      gallery: {
        view: "View",
        unavailable: "Image not available"
      },
      reviews: {
        title: "Customer Reviews",
        based_on: "Based on {{count}} reviews",
        write_review: "Write a Review",
        rating_label: "Rating",
        comment_label: "Comment",
        comment_placeholder: "Share your experience...",
        submitting: "Submitting...",
        submit: "Submit Review",
        login_to_review: "Please login to leave a review.",
        login_link: "Login",
        count: "({{count}} reviews)",
        empty: "No reviews yet."
      }
    },
    ProductDetailPage: {
      state: {
        loading: "Loading...",
        notFound: "Product not found."
      },
      hero: {
        reviewsCount: "{{count}} reviews"
      },
      description: {
        title: "What you get",
        subtitle: "Included features"
      },
      configurator: {
        title: "Customization & Options",
        required: "Required",
        amountPlaceholder: "Enter amount",
        currencyUnit: "DT",
        fileUploading: "Loading...",
        fileAdded: "File added",
        addFile: "Add a file",
        uploadError: "Upload error.",
        includedWithChoices: "Included with your choices",
        unitPrice: "Unit price",
        estimatedTotal: "Estimated total",
        minQuantityGros: "Minimum quantity: {{min}} (wholesale)"
      },
      cta: {
        soldOut: "Sold out",
        orderNow: "Order now"
      },
      similar: {
        title: "Similar products",
        items: "items"
      },
      preferences: {
        labels: {
          typeDeCompte: "Account type",
          fullName: "Full name",
          phone: "Phone",
          email: "Email",
          duree: "Duration",
          productLink: "Product link to purchase",
          productPriceTnd: "Product price (TND)",
          productScreenshot: "Product screenshot",
          intlDelivery: "International delivery",
          subscriptionDuration: "Subscription duration",
          language: "Language",
          regionalAdmin: "Regional administration",
          school: "School",
          teacherName: "Teacher name",
          levelsTaught: "Levels taught",
          sheetCount: "Number of sheets (front / back)",
          spiralBinding: "Spiral binding",
          templateNumber: "Template No.",
          otherInstructions: "Other instructions",
          printing: "Printing"
        },
        options: {
          yearlyOffer: "Annual offer",
          lifetimeOffer: "Lifetime offer",
          oneYear: "1 Year",
          oneMonth: "1 Month",
          threeMonths: "3 Months",
          fourMonths: "4 Months",
          sixMonths: "6 Months",
          twelveMonths: "12 Months",
          essentiel: "Essential",
          standard: "Standard",
          premium: "Premium",
          free: "Free",
          paid: "Paid",
          french: "French",
          english: "English",
          arabic: "Arabic",
          sheets40: "40",
          sheets60: "60",
          sheets80: "80",
          spiralPlastic: "Plastic spiral",
          spiralMetal: "Metal spiral",
          hotBinding: "Hot binding",
          blackWhite: "Black & White",
          color: "Color",
          shared: "Shared",
          personal: "Personal"
        },
        features: {
          productPriceInflated: "product price will be increased",
          productPriceReduced: "product price will be reduced",
          smallPrice90Days: "Low price for 90 days",
          bestValue: "Best value",
          upTo2MonthsFree: "Up to 2 months free",
          netflix1Device: "Watch Netflix Tunisia on 1 compatible device at a time",
          netflix2Devices: "Watch Netflix Tunisia on 2 compatible devices at a time",
          netflix4Devices: "Watch Netflix Tunisia on 4 compatible devices at a time",
          netflix720p: "Watch Netflix Tunisia in 720p (HD)",
          netflix1080p: "Watch Netflix Tunisia in 1080p (Full HD)",
          netflix4k: "Watch Netflix Tunisia in 4K (Ultra HD) + HDR",
          download1Device: "Download titles on 1 compatible device at a time",
          download2Devices: "Download titles on 2 compatible devices at a time",
          download6Devices: "Download titles on 6 compatible devices at a time"
        }
      }
    },
    orders: {
      page_title: "My Orders",
      empty: "Aucune commande trouvée.",
      processing_message: "Your order is being processed. You will be notified by email shortly.",
      view_codes: "View Codes",
      track_package: "Tracking Number"
    },
    deposits: {
      page_title: "My Deposits",
      new_deposit: "New Deposit",
      amount_label: "Amount",
      payment_method: "Payment Method",
      instructions_header: "Payment Instructions",
      proof_label: "Proof of Payment",
      history_title: "Deposit History",
      empty: "Aucun dépôt trouvé.",
      submit_btn: "Submit Deposit"
    },
    my_codes: {
      title: "My Codes",
      history: "History",
      select_hint: "Sélectionnez un code dans la liste pour voir les détails.",
      empty_codes: "Aucun code trouvé.",
      security_title: "Consignes de sécurité",
      security_desc: "Ce code est strictement confidentiel. Ne partagez jamais de captures d",
      history_desc: "Veuillez choisir un code dans la liste pour voir les détails."
    },
    tickets: {
      page_title: "Support Tickets",
      open_new: "Open New Ticket",
      subject: "Subject",
      type: "Type",
      status: "Status",
      last_update: "Last Updated",
      no_tickets: "No tickets found.",
      form_title: "New Ticket",
      message_placeholder: "Describe your issue...",
      attachment: "Attachment (Optional)",
      back_to_list: "← Back to list",
      reply_placeholder: "Reply...",
      sending: "Sending...",
      reply_btn: "Send Reply",
      close_ticket: "Close Ticket",
      close_confirm_title: "Confirm Closure",
      close_confirm_message: "Are you sure you want to close this ticket? Once closed, you will no longer be able to reply to it."
    },
    SupportTickets: {
      table: {
        id: "ID",
        title: "My Tickets",
        lastUpdate: "Last update:",
        ticketSingular: "ticket",
        ticketPlural: "tickets"
      },
      empty: {
        description: "Create a ticket for any question, technical issue or complaint; our team will get back to you promptly."
      },
      context: {
        orderRef: "Order reference:",
        module: "Related module:",
        environment: "Environment:"
      },
      modal: {
        info: {
          autoContactInfo: "Your account will be automatically linked to this ticket (name, email)."
        }
      },
      form: {
        type: {
          orderIssue: "Order Issue"
        },
        order: {
          relatedOrderLabel: "Related order",
          selectOrderPlaceholder: "Select an order",
          noOrders: "You don't have any orders."
        },
        support: {
          moduleLabel: "Related module (optional)",
          modulePlaceholder: "Ex: Payment, My codes, Delivery...",
          environmentLabel: "Environment (optional)",
          environmentPlaceholder: "Ex: Chrome 120, Windows 11 / Safari iOS 17..."
        }
      },
      messages: {
        selectOrderRequired: "Please select the related order.",
        createdRef: "Ticket #{{ref}} was created successfully. You can track its progress below."
      }
    },
    profile: {
      information: "Information",
      balance: "Balance TND",
      orders: "Orders",
      update_success: "Profile updated!",
      settings: {
        language: "Language",
        theme: {
          dark: "Dark mode",
          light: "Light mode"
        },
        notifications: "Notifications",
        notifications_desc: "Receive notifications"
      },
      security: {
        title: "Sécurité",
        change_password: {
          desc: "Mettez à jour votre mot de passe régulièrement"
        },
        current_password: "Mot de passe actuel",
        new_password: "Nouveau mot de passe",
        confirm_password: "Confirmer le mot de passe",
        forgot_password: "Mot de passe oublié ?",
        update_password: "Mettre à jour le mot de passe",
        tips: {
          1: "Utilisez un mot de passe fort et unique",
          2: "Changez votre mot de passe régulièrement",
          3: "Ne partagez jamais votre mot de passe",
          title: "Conseils de sécurité"
        },
        "2fa": {
          title: "Authentification à deux facteurs",
          disabled: "Protection supplémentaire pour votre compte",
          enable: "Activer la 2FA",
          enabled: "Protection activée",
          regenerate_codes: "Régénérer les codes de récupération",
          disable: {
            title: "Désactiver la 2FA",
            warning: "Pour des raisons de sécurité, veuillez confirmer votre mot de passe pour désactiver la 2FA.",
            confirm: "Désactiver"
          },
          setup: {
            title: "Configuration Google Authenticator",
            step1: "Étape 1 : Ajouter à Google Authenticator",
            step1_1: "Ouvrez Google Authenticator sur votre téléphone",
            step1_2: "Appuyez sur ",
            step1_3: "Sélectionnez ",
            step2: "Étape 2 : Entrer la clé secrète",
            secret_warning: "IMPORTANT : Entrez la clé SANS tirets, espaces ou séparateurs",
            secret_note: "Type : Basé sur le temps | Algorithme : SHA1",
            step3: "Étape 3 : Vérifier le code"
          },
          verify: "Vérifier et activer",
          recovery_codes: {
            title: "Codes de récupération",
            warning: "⚠️ IMPORTANT : Enregistrez ces codes dans un endroit sûr. Ils ne seront plus affichés.",
            saved: "J\\"
          }
        }
      }
    },
    AdminDashboard: {
      header: {
        title: "Admin Dashboard"
      },
      noData: "No data available",
      filters: {
        period: "Period",
        today: "Today",
        last7Days: "Last 7 days",
        last30Days: "Last 30 days",
        last90Days: "Last 90 days",
        clientType: "Type",
        all: "All",
        allFeminine: "All",
        new: "New",
        loyal: "Loyal",
        inactive: "Inactive",
        spending: "Spending",
        low: "Low",
        medium: "Medium",
        high: "High"
      },
      exportCsv: "Export CSV",
      kpi: {
        totalClients: "Total clients",
        newRegistrations: "New registrations",
        activeClients: "Active clients",
        inactiveClients: "Inactive clients",
        usersWithoutAction: "Registered with no activity",
        revenueGenerated: "Revenue generated",
        retentionRate: "Retention rate",
        mostLoyalClient: "Most loyal client",
        orders: "orders"
      },
      chartLabels: {
        active: "Active",
        inactive: "Inactive",
        noAction: "No action"
      },
      charts: {
        registrationsEvolution: "Registration trend",
        revenueEvolution: "Revenue trend",
        topLoyalClients: "Top loyal clients",
        clientDistribution: "Client distribution"
      },
      insights: {
        title: "Client Insights",
        mostLoyal: "Most loyal client",
        atRisk: "At-risk clients",
        noRisk: "No at-risk clients",
        highPotential: "High-potential new clients",
        noPotential: "No high-potential new clients",
        totalSpent: "total spent",
        daysAgo: "days ago"
      },
      clientsTable: {
        title: "Client summary",
        name: "Name",
        email: "Email",
        registrationDate: "Registration date",
        lastActivity: "Last activity",
        ordersCount: "Orders",
        totalSpent: "Total spent",
        status: "Status",
        actions: "Actions"
      },
      status: {
        new: "New",
        loyal: "Loyal",
        inactive: "Inactive"
      },
      never: "Never",
      viewProfile: "View profile",
      notAvailable: "N/A",
      unknown: "Unknown",
      exportHeaders: {
        name: "Name",
        email: "Email",
        registrationDate: "Registration date",
        lastActivity: "Last activity",
        ordersCount: "Orders",
        totalSpent: "Total spent",
        status: "Status"
      }
    },
    SecurityDashboard: {
      header: {
        title: "Security & Quality"
      },
      ipBlocked: {
        title: "Blocked IPs",
        last24h: "New IPs blocked in last 24h"
      },
      ipActivity: {
        title: "IP activity (24h)",
        hint: "IPs that hit sensitive endpoints"
      },
      otp: {
        title: "OTP (total)",
        sent: "sent",
        validationRate: "Validation rate"
      },
      tickets: {
        openTickets: "Open tickets",
        firstResponse: "Avg. first response time"
      },
      reviews: {
        title: "Client reviews (30d)",
        avgRating: "Average rating"
      },
      twoFa: {
        title: "2FA-enabled accounts",
        hint: "Users with strong authentication"
      },
      expired: {
        expired24h: "Expired accounts (24h)",
        hint: "Created but not activated in time",
        total: "Expired accounts (total)",
        totalHint: "History of auto-cleaned accounts"
      },
      notAvailable: "N/A"
    },
    ManageUsers: {
      header: {
        title: "Manage Users"
      },
      addButton: "Add User",
      filters: {
        searchPlaceholder: "Search...",
        statusLabel: "Filter by status",
        all: "All",
        showAllAccounts: "Show all accounts",
        showExpiredOnly: "Show expired accounts only",
        deleteSelected: "Delete selected accounts"
      },
      table: {
        client: "Client",
        status: "Status",
        balance: "Balance",
        activity: "Activity",
        registration: "Registration",
        actions: "Actions",
        orders: "Orders",
        deposits: "Deposits"
      },
      loading: "Loading...",
      emptyState: "No clients found.",
      messages: {
        fetchError: "Failed to fetch users",
        bulkDeleteSuccess: "Expired accounts deleted successfully.",
        bulkDeleteError: "Error during bulk deletion.",
        statusUpdated: "Status updated.",
        checkDepsError: "Unable to check dependencies.",
        deleteSuccess: "User deleted successfully.",
        deleteError: "Error during deletion."
      },
      bulkDelete: {
        confirm: "Permanently delete {{count}} expired account(s)? This action cannot be undone."
      },
      deleteModal: {
        title: "Delete {{name}}?",
        analyzing: "Analyzing data...",
        hasDependencies: "Warning: This client has {{count}} linked item(s).",
        orders: "Orders",
        deposits: "Deposits",
        tickets: "Tickets",
        reviews: "Reviews",
        forceDeleteWarning: "Forcing deletion will permanently erase all linked history.",
        noDependencies: "No linked data found. Deletion is safe.",
        cancel: "Cancel",
        deleting: "Deleting...",
        forceDelete: "Delete (Force)",
        confirm: "Confirm"
      },
      addModal: {
        title: "New client",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        password: "Password",
        phonePlaceholder: "+216 XX XXX XXX",
        address: "Address",
        cancel: "Cancel",
        createAccount: "Create account",
        emailInvalid: "Invalid email format.",
        phoneInvalid: "Invalid phone. Use +216 XX XXX XXX"
      }
    },
    ManageOrders: {
      modal: {
        orderTitle: "Order #{{id}}",
        close: "Close",
        subtotal: "Subtotal",
        deliveryFee: "Delivery fee",
        stampFee: "Stamp fee",
        total: "Total",
        deliveryAction: "Delivery Action",
        productConcerned: "Product concerned",
        identifierEmail: "Identifier / Email",
        emailPlaceholder: "email@example.com",
        password: "Password",
        passwordPlaceholder: "••••••••",
        licenceKey: "Licence key",
        licencePlaceholder: "XXXXX-XXXXX-XXXXX-...",
        certificateLink: "Certificate link (optional)",
        urlPlaceholder: "https://...",
        invitationUrl: "Invitation URL (Canva, Google Family, etc.)",
        trackingLink: "Tracking link",
        trackingPlaceholder: "Tracking number or link",
        noteToClient: "Note to client",
        notePlaceholder: "Instructions or message to client...",
        codeLabel: "Code (gift card / voucher)",
        codePlaceholder: "Code sent by email",
        codesAssigned: "Assigned codes (automatic delivery)",
        codesAssignedShort: "Assigned codes:",
        codeInstantInfo: "Instant code: delivered automatically when the order is validated or already shown in the product list below.",
        saving: "Saving...",
        saveAndSend: "Save and Send",
        productsCount: "Products ({{count}})",
        ship: "Ship",
        delivered: "Delivered",
        resolveProblem: "Resolve issue",
        resolveTitle: "Resolve issue — Order #{{id}}",
        step: "Step {{step}}",
        problemType: "Problem type:",
        action: "Action:",
        quantityToReplace: "Quantity to replace per line (stock checked on creation):",
        max: "max {{count}}",
        compensationCart: "Compensation cart (stock checked on creation):",
        chooseProduct: "Choose a product",
        add: "Add",
        summaryAndOptions: "Summary and options:",
        problem: "Problem:",
        actionLabel: "Action:",
        quantities: "Quantities:",
        compensationLines: "{{count}} compensation line(s)",
        internalNote: "Internal note (optional)",
        internalNotePlaceholder: "Comment for audit...",
        riskLevel: "Risk level (optional)",
        notSpecified: "— Not specified —",
        riskLow: "Low",
        riskMedium: "Medium",
        riskHigh: "High",
        evidenceRequested: "Evidence requested from client",
        cancel: "Cancel",
        back: "Back",
        sending: "Sending...",
        confirm: "Confirm",
        next: "Next",
        remove: "Remove",
        indicateQuantity: "Specify at least one quantity to replace.",
        addCompensation: "Add at least one product to compensation.",
        instantCodesDelivered: "This order has already delivered instant codes. The 'Completed' status cannot be applied a second time.",
        trackingNumber: "Tracking number"
      },
      filters: {
        searchPlaceholder: "Search by order #, client, email...",
        reset: "Reset",
        type: "Type",
        all: "All",
        standard: "Standard",
        replacement: "Replacement",
        compensation: "Compensation",
        paid: "Paid",
        free: "Free (0)",
        allStatus: "All",
        ordersCount: "{{count}} / {{total}} order(s)"
      },
      table: {
        typeInfo: "Type / Info",
        replacement: "Replacement",
        compensation: "Compensation",
        originalOrder: "Original order",
        problemResolved: "Issue resolved"
      }
    },
    AdminProfile: {
      header: {
        title: "Admin Profile",
        cancel: "Cancel",
        saving: "Saving...",
        save: "Save",
        editProfile: "Edit profile"
      },
      loading: "Loading profile...",
      banner: {
        avatar: "Avatar",
        adminSpace: "Admin area",
        backOffice: "eServices.tn back-office management",
        securityTitle: "Account security",
        securityDescription: "Keep your email and phone number up to date for a more secure experience."
      },
      messages: {
        success: "Profile updated successfully!",
        error: "Error updating profile."
      },
      personalInfo: {
        title: "Personal information",
        firstName: "First name",
        lastName: "Last name",
        address: "Postal address"
      },
      contact: {
        title: "Contact & login",
        loginEmail: "Login email",
        phone: "Phone number",
        notProvided: "Not provided",
        usageNote: "Contact information is used for account recovery, critical notifications and identity verification."
      }
    },
    admin: {
      nav: {
        dashboard: "Dashboard",
        deposits: "Manage Deposits",
        orders: "Manage Orders",
        stock: "Manage Stock",
        products: "Manage Products",
        categories: "Manage Categories",
        media: "Media Library",
        security: "Security",
        users: "Users",
        tickets: "Support / Tickets",
        payment_methods: "Payment methods",
        delivery_settings: "Delivery",
        settings: "Site Settings",
        view_site: "View Site"
      },
      dashboard: {
        title: "Administration",
        total_revenue: "Total Revenue",
        total_users: "Registered Clients",
        total_orders: "Total Orders",
        pending_deposits: "Pending Deposits",
        revenue_by_operator: "Revenue by Operator",
        orders_status: "Order Status",
        revenue: "Revenue",
        orders: "commandes"
      },
      profile: {
        title: "Admin Profile",
        cancel: "Cancel",
        saving: "Saving...",
        save: "Save",
        edit: "Edit",
        success: "Profile updated successfully!",
        error: "Error updating profile.",
        loading: "Loading profile...",
        first_name: "First Name",
        last_name: "Last Name",
        email: "Email",
        phone: "Phone",
        address: "Address",
        avatar: "Avatar"
      },
      preferences: {
        title: "Payment Preferences",
        add_method: "Add Method",
        update_success: "Préférence mise à jour.",
        create_success: "Nouvelle préférence ajoutée.",
        delete_success: "Préférence supprimée.",
        load_error: "Erreur lors du chargement des préférences.",
        delete_confirm: "Are you sure you want to delete this entry?",
        edit_title: "Edit",
        add_title: "Add",
        method_subtitle: "a payment method",
        category: "Category",
        category_bank: "Bank",
        category_ccp: "CCP (Post)",
        category_wallet: "Wallet",
        provider_name: "Provider Name",
        identifier: "Identifier (RIB, Phone)",
        iban_optional: "IBAN (Optional)",
        account_holder_optional: "Holder (Optional)",
        cancel: "Cancel",
        save: "Save",
        edit_tooltip: "Edit",
        duplicate_tooltip: "Duplicate",
        delete_tooltip: "Delete",
        identifier_label: "Identifier / RIB / Phone",
        iban_label: "IBAN",
        holder_label: "Holder"
      },
      payment_methods: {
        page_title: "Payment methods",
        page_subtitle:
          "Configure payment credentials (bank details, wallets, postal…) shown to customers. Full rules (rails, enums, cart) are documented in docs/paiement-moyens.md.",
        section_deposits: "Balance top-ups (deposits)",
        section_deposits_hint: "PostgreSQL enum deposit_method — internal balance is not a deposit method.",
        section_orders: "Order checkout",
        section_orders_hint: "PostgreSQL enum order_payment_method — includes pay on delivery.",
        section_products: "Allowed methods per product",
        section_products_hint: "PostgreSQL payment_method[] on products.",
        rules_title: "Rules enforced in the app",
        rule_deposits: "Deposits only use deposit_method (transfer to identifier/wallet, postal order, Flouci, D17, bank transfer) — never internal balance.",
        rule_instant: "Instant code products: only internal balance at checkout.",
        rule_non_instant: "Other delivery modes: all relevant order methods (balance, pay on delivery, Flouci, D17, wire) according to cart and product rules.",
        rule_admin_table: "Each row has a business code (same text as PostgreSQL enums) and checkboxes for order / deposit / product catalog to control where credentials appear.",
        credentials_title: "Payment credentials (admin_payment_settings)",
        disabled_badge: "Disabled",
        scope_short_order: "Order",
        scope_short_deposit: "Deposit",
        scope_short_product: "Catalog",
        card: {
          sort: "Sort",
          created: "Created",
        },
        payment_setting_category: {
          carte_bancaire: "Bank card",
          carte_prepayee: "Prepaid card",
          carte_credit: "Credit card",
          carte_debit: "Debit card",
          virement_bancaire: "Bank transfer",
          virement_postal: "Postal / giro transfer",
          p2p: "Peer-to-peer (P2P)",
          portefeuille_electronique: "E-wallet",
          portefeuille_mobile: "Mobile wallet",
          solde_interne: "Internal balance",
          mandat_cash: "Cash mandate",
          mandat_compte: "Account mandate",
          mandat_postal: "Postal mandate",
          mandat_bancaire: "Bank mandate / transfer (e.g. MoneyGram)",
          cheque_bancaire: "Bank cheque",
          cheque_postal: "Postal cheque",
          cheque_vacances: "Holiday voucher cheque",
          especes: "Cash",
          prelevement_automatique: "Direct debit",
          cryptomonnaie: "Cryptocurrency",
          autre: "Other",
        },
        form: {
          category_group_enum: "Categories (PostgreSQL enum)",
          category_group_legacy: "Legacy text categories",
          method_code: "Business code (enum value)",
          method_code_hint:
            "Admin codes: virement_bancaire, virement_postal (giro/CCP), mandat_postal, mandat_bancaire (e.g. MoneyGram). Client order/deposit enums still use virement / postal.",
          optgroup_order_product: "Orders & catalog — bank / postal transfers",
          optgroup_deposit_extra: "Deposits — postal mandate, bank mandate, P2P",
          scope_order: "Use for order checkout",
          scope_deposit: "Use for balance top-ups / deposits",
          scope_product: "Reference for product allowed methods (display / rules)",
          sort_order: "Display order",
          instructions: "Instructions (optional)",
          instructions_placeholder: "Optional text shown to the customer for this row.",
          enabled: "Active",
          error_method_code: "Invalid business code.",
          error_scope: "Select at least one scope: order, deposit or catalog.",
          error_identifier_portefeuille:
            "For a mobile wallet, the phone number identifier is required.",
          error_identifier_phone:
            "Enter a valid Tunisia mobile number (8 digits, prefixes 2, 3, 4, 5 or 9 after +216).",
          error_identifier_rib_required: "RIB is required for a bank transfer.",
          error_identifier_rib_format: "RIB must be exactly 20 digits.",
          error_identifier_ccp_required: "CCP / postal account number is required for a postal transfer.",
          error_identifier_ccp_format: "CCP must be between 10 and 16 digits.",
          identifier_label_portefeuille: "Phone number (TN mobile) — required",
          identifier_label_virement: "RIB (20 digits) — required",
          identifier_label_virement_postal: "CCP / postal account — required",
          identifier_label_mandat: "National ID / reference (optional)",
          identifier_label_optional: "Identifier (optional)",
          error_provider: "Account / provider name is required."
        }
      },
      categories: {
        title: "Manage Categories",
        add: "Add Category",
        new_category: "New Category",
        name: "Name",
        desc: "Description",
        cover_image: "Cover Image",
        subcategories_list: "Sub-categories:",
        new_subcategory: "New Sub-category",
        add_sub: "Add Sub-cat"
      },
      products: {
        title: "Products Management",
        add: "Add",
        edit: "Edit",
        form: {
          title_new: "New Product",
          title_edit: "Edit Product",
          name: "Product Name",
          category: "Category",
          price: "Base Price (TND)",
          subcategory: "Sub-category",
          description: "Description",
          description_placeholder: "Description détaillée du produit...",
          status_label: "Status",
          status: {
            on_sale: "On sale",
            incoming: "Incoming",
            sold_out: "Sold out"
          },
          value: "Value",
          value_placeholder: "Ex: 1 Go, 5 TND...",
          min_quantity: "Minimum quantity",
          delivery_method: "Delivery method",
          sale_type: "Sale type",
          payment_methods: "Payment methods",
          validated: "Validated product",
          best_seller: "Best seller",
          duplicate_suffix: "(Copy)",
          show_preview: "Preview product",
          hide_preview: "Hide preview",
          desc: "Description",
          delivery_mode: "Delivery Method",
          best_seller_old: "🔥 Top Seller",
          active_product: "Active Product",
          save: "Save",
          images: {
            logo: "1. Logo / Marque",
            main: "2. Image Principale",
            gallery: "3. Autres images (Galerie)"
          },
          preferences: {
            title: "Pricing Options",
            add_group: "+ OPTIONS GROUP",
            group_placeholder: "Ex: Cover type",
            option_placeholder: "Ex: Rigid",
            required: "Required",
            features_label: "Included services (one per line)",
            features_placeholder: "Saisir les fonctionnalités...",
            add_value: "+ NEW VALUE",
            conditions: {
              if: "IF",
              group_select: "Groupe...",
              value_select: "Valeur...",
              then_price: "THEN SUPPLEMENT =",
              features_label: "INCLUDED SERVICES (IF CONDITION)",
              features_placeholder: "Fonctionnalités spécifiques...",
              add: "+ Pricing condition"
            }
          },
          delivery_methods: {
            code_instantane: "Instant code",
            mail_compte_code: "Mail account code",
            mail_code: "Mail code",
            mail_acces: "Mail access",
            mail_licence: "Mail license",
            traitement_lien: "Link processing",
            livraison_domicile: "Home delivery"
          },
          sale_types: {
            detail: "Retail",
            gros: "Wholesale"
          },
          payment_methods_labels: {
            solde: "Balance",
            livraison: "Delivery",
            carte: "Card",
            mandat: "Money order",
            p2p: "P2P",
            solde_interne: "Internal balance",
            portefeuille: "Mobile wallet",
            virement: "Bank transfer",
            flouci: "Flouci",
            d17: "D17",
            izi_pay: "IZI Pay",
            carte_bancaire: "Credit card"
          },
          preview: {
            title: "Preview",
            preferences: "Customization",
            product_name_placeholder: "Product name",
            value_label: "Value",
            select_placeholder: "Sélectionner...",
            input_placeholder: "Enter {{field}}",
            amount_placeholder: "Amount",
            estimated_total: "Estimated total price",
            file_placeholder: "File to upload"
          },
          validation: {
            name_required: "Product name is required",
            price_required: "Price must be greater than 0",
            subcategory_required: "Sub-category is required",
            min_quantity_invalid: "Minimum quantity must be at least 1",
            preference_label_required: "Preference {{index}} label is required",
            preference_options_required: "Preference \\",
            option_name_required: "Option {{optionIndex}} name of \\"
          },
          submit: {
            processing: "TRAITEMENT...",
            update: "UPDATE",
            create: "SAVE PRODUCT"
          }
        },
        main_image_section: {
          no_image: "No image",
          upload_pc: "Upload from PC",
          choose_library: "Choose from library",
          format: "Format : JPG, PNG ou SVG. Max 2Mo."
        },
        gallery: {
          add: "+ Add images",
          empty: "Aucune image dans la galerie.",
          new_label: "New",
          view: "Vue"
        },
        filter_title: "Filter Products",
        filters: {
          search_label: "Search",
          search_placeholder: "Nom du produit...",
          category_label: "Category",
          subcategory_label: "Sub-category",
          all: "All"
        },
        list: {
          empty: "No products found",
          base_price_suffix: "(Base)",
          duplicate: "Duplicate",
          edit: "Edit",
          delete: "Delete"
        },
        messages: {
          confirm_delete: "Delete this product?",
          required_error: "Required fields missing."
        },
        main_image: "admin.products.main_image",
        validation: {
          name_required: "Le nom du produit est requis",
          price_required: "Le prix doit être supérieur à 0",
          subcategory_required: "La sous-catégorie est requise",
          min_quantity_invalid: "La quantité minimale doit être au moins 1",
          preference_label_required: "Le label de la préférence {{index}} est requis",
          preference_options_required: "La préférence \\",
          option_name_required: "Le nom de l"
        }
      },
      media: {
        title: "Media Library",
        sync: "Sync",
        upload: "Upload",
        search: "Rechercher une image...",
        filename: "Filename",
        type: "Type",
        size: "Size",
        added_on: "Added on",
        delete_confirm: "Delete permanently?",
        details: "Details",
        usage: "Usage",
        bucket: "Bucket",
        all_buckets: "All buckets"
      },
      tickets: {
        title: "Manage Support",
        status_tabs: {
          open: "Open",
          in_progress: "In Progress",
          closed: "Closed",
          all: "All"
        },
        filters: {
          all_types: "All Types",
          all_priorities: "All Priorities"
        },
        table: {
          id: "ID",
          client: "Client",
          subject: "Subject",
          type: "Type",
          priority: "Priority",
          status: "Status",
          last_update: "Update"
        },
        no_results: "Aucun ticket trouvé.",
        ticket_prefix: "Ticket #",
        status_label: "Status:",
        load_error: "Failed to load ticket.",
        loading: "Loading ticket...",
        not_found: "Ticket not found.",
        reply_placeholder: "Admin reply...",
        sending: "Sending...",
        send_reply: "Send Reply",
        back_to_list: "← Back to list",
        client_info: "Client Info",
        view_profile: "View Profile",
        guest_title: "Guest",
        name_label: "Name:",
        email_label: "Email:",
        source_label: "Source:",
        created_label: "Created:",
        configuration: "Configuration",
        priority_label: "Priority",
        type_label: "Type",
        support_name: "Support Services",
        guest_name: "Guest",
        conversations: {
          no_conversations: "Aucune conversation",
          no_conversations_desc: "Ce client n\\",
          no_conversations_filter: "Aucune conversation avec ce statut.",
          create_new: "Nouvelle conversation",
          you: "Vous",
          created: "Créé",
          create_desc: "Fonctionnalité à implémenter - création de ticket depuis mobile admin"
        },
        messages: {
          attachment: "Pièce jointe",
          no_messages: "Aucun message dans cette conversation",
          reply_placeholder: "Réponse...",
          change_status: "Changer le statut"
        },
        clients: {
          title: "Clients avec Tickets",
          search_placeholder: "Nom, valeur...",
          no_clients: "Aucun client trouvé",
          no_results_search: "Aucun résultat pour votre recherche.",
          no_results: "Aucun ticket trouvé.",
          active: "actif(s)",
          last_activity: "Dernière activité",
          total_tickets: "ticket(s)",
          closed: "fermé(s)"
        }
      },
      deposits: {
        title: "Manage Deposits",
        pending: "Pending",
        all: "All",
        allMethods: "All methods",
        filterByMethod: "Filter by method",
        client: "Client",
        amount: "Amount",
        method: "Method",
        date: "Date",
        confirm_refuse: "Are you sure you want to refuse this deposit?",
        confirm_validate: "Confirm validation of deposit for",
        proof: "View Proof",
        validate: "Validate",
        refuse: "Refuse",
        proof_viewer: "Payment proof",
        code_viewer: "Transaction code",
        transactionRef: "Transaction reference",
        mandatType: "Mandate type",
        clientName: "Client name",
      },
      stock: {
        title: "Stock Management",
        sync_btn: "Sync Statuses",
        digital_tab: "Digital Stock",
        physical_tab: "Physical Stock",
        import_title: "Import Codes",
        import_desc: "Import codes via CSV (Format: Code;Serial)",
        product: "Product",
        choose: "Choisir...",
        file_csv: "CSV File",
        import_btn: "Import",
        state_title: "Digital Stock State",
        available: "Avail.",
        sold: "Sold",
        status_base: "Status (Base)",
        inventory_title: "Inventory / Processing",
        history: "History",
        adjust: "Adjust",
        movement_type: "Movement Type",
        reason: "Reason",
        sync_statuses: "Sync Statuses",
        digital_stock: "Digital Stock",
        physical_stock: "Physical Stock",
        import_codes: "Importation",
        digital_stock_status: "Digital Stock State",
        product_header: "Product",
        available_header: "Dispo.",
        sold_header: "Sold",
        status_base_header: "Status",
        import: "Importer",
        no_instant_product: "No instant code product",
        import_instant_only: "Import is only for « Code instantané » products.",
        instant_codes: "Instant code",
        manual_digital: "Manual (deferred code)",
        set_sold_out: "Set Sold out",
        set_on_sale: "Set On sale"
      },
      users: {
        title: "Manage Users",
        add: "Add User",
        search: "Rechercher...",
        filter_status: "Filter Status",
        all: "All",
        details: "Details",
        suspended_btn: "Suspend",
        active_btn: "Activate",
        activity: "Activity",
        registered: "Registered on",
        detail: {
          save_success: "Profile updated.",
          status_success: "Status updated.",
          confirm_reset: "Send password reset to {{email}}?",
          reset_sent: "Reset email sent.",
          delete_title: "Delete client {{name}}?",
          checking_deps: "Checking linked data...",
          deps_warning: "Warning: This client has:",
          tabs: {
            orders: "Orders",
            deposits: "Deposits",
            tickets: "Tickets"
          },
          reviews: "Reviews",
          deps_loss: "Deletion will erase all related history.",
          no_deps: "No linked data. Safe to delete.",
          force_delete: "Delete All (Force)",
          deleting: "Deleting...",
          balance_modal: {
            title: "Manage Balance",
            current: "Current Balance:",
            operation: "Operation",
            add: "Add",
            subtract: "Subtract",
            set: "Set",
            new_balance: "New Balance",
            amount: "Amount",
            success: "Balance updated: {{amount}}"
          },
          loading: "Loading...",
          not_found: "User not found.",
          edit_profile: "Edit Profile",
          personal_info: "Personal Information",
          account_management: "Account Management",
          account_status: "Account Status",
          manage_balance: "Manage Balance",
          reset_password: "Reset Password",
          delete_client: "Delete Client"
        }
      },
      settings: {
        title: "General Settings",
        app_prefs: "App Preferences",
        interface_theme: "Interface Theme",
        sticky_bar: "Sticky Filter Bar",
        language: "Language"
      },
      deliverySettings: {
        title: "Delivery Settings",
        baseFeeLabel: "Base delivery fee",
        baseFeeHint: "Default amount for home delivery. Applies to all regions unless overridden.",
        stampFeeLabel: "Stamp fee",
        stampFeeHint: "0.100 TND stamp fee applied per order with home delivery.",
        saveBtn: "Save",
        saving: "Saving...",
        saved: "Settings saved successfully.",
        error: "Error saving settings."
      },
      orders: {
        title: "Manage Orders",
        duplicate: "Duplicate",
        delete: "Delete",
        details: "Details",
        confirm_delete: "Delete this order?",
        confirm_delete_bulk: "Delete {{count}} order(s)? This action is irreversible.",
        confirm_duplicate: "Duplicate this order?",
        client: "Client",
        total: "Total",
        payment: "Payment",
        status: "Status",
        ref_trans: "Trans Ref",
        transactionRef: "Transaction reference",
        clientName: "Client name",
        mandatNumber: "Money order number",
        proof: "Payment proof",
        openProof: "Open proof",
        paymentDetail: "Payment detail",
        generate_invoice: "Generate Invoice",
        generate_bl: "Generate BL",
        view_invoice: "View Invoice",
        ref: "Ref",
        deleted_one: "Order deleted.",
        deleted_bulk: "{{count}} order(s) deleted.",
        select_all: "Select all",
        clear_selection: "Clear selection",
        delete_selection: "Delete selection",
        selected_one: "order selected",
        selected_bulk: "orders selected"
      }
    },
    delivery: {
      instructions: {
        code_instantane: "Code displayed immediately in your account.",
        mail_compte_code: "Account + Code sent by email.",
        mail_code: "Code sent by email.",
        mail_acces: "Access credentials sent by email.",
        mail_licence: "License sent by email.",
        traitement_lien: "Processing will be done remotely once order is validated.",
        livraison_domicile: "Physical delivery to your address.",
        default: "Standard delivery mode."
      },
      methods: {
        code_instantane: "Instant Code",
        mail_compte_code: "Account (Mail)",
        mail_code: "Code (Mail)",
        mail_acces: "Access (Mail)",
        mail_licence: "License (Mail)",
        traitement_lien: "Service / Processing",
        livraison_domicile: "Home Delivery"
      }
    },
    payment: {
      methods: {
        solde_interne: "Internal Balance",
        carte_bancaire: "Credit Card",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "Bank Transfer"
      }
    },
    payment_methods: {
      solde: "Balance payment",
      mandat: "Money order",
      carte: "Card payment",
      solde_interne: "Internal Balance",
      livraison: "Pay on delivery",
      portefeuille: "Mobile wallet",
      p2p: "Transfer to identifier (deposit)",
      postal: "Postal mandate",
      mandat_postal: "Postal mandate (admin code)",
      mandat_bancaire: "Bank mandate (e.g. MoneyGram)",
      carte_bancaire: "Credit Card",
      flouci: "Flouci",
      d17: "D17",
      izi_pay: "IZI Pay",
      virement: "Bank transfer",
      virement_bancaire: "Bank wire (admin code)",
      virement_postal: "Postal / giro transfer (CCP)"
    },
    delivery_instructions: {
      code_instantane: "Instant Code",
      mail_compte_code: "Account + Code (Email)",
      mail_code: "Code (Email)",
      mail_acces: "Access (Email)",
      mail_licence: "License (Email)",
      traitement_lien: "Remote Processing",
        livraison_domicile: "Home Delivery",
        free: "Free"
      },
    ticket_types: {
      SUPPORT: "Support",
      COMMANDE: "Order",
      CONTACT: "Contact"
    },
    product_names: {
    },
    categories: {
      Recharge: "Mobile Recharge",
      "Recharge Mobile": "Mobile Recharge",
      "Documents personnalisés": "Custom Documents",
      "Paiement International": "International Payment",
      Jeux: "Video Games",
      Streaming: "Streaming & TV",
      Logiciels: "Software & VPN",
      Paiement: "Payment Cards",
      Divers: "Miscellaneous",
      Abonnements: "Subscriptions"
    },
    categories_desc: {
      Abonnements: "Streaming services, games and more."
    },
    subcategories: {
      Ooredoo: "Ooredoo",
      Orange: "Orange",
      Streaming: "Streaming",
      Gaming: "Gaming",
      "Conception graphisque": "Graphic Design",
      "Tunisie Télécom": "Tunisie Telecom",
      "Paiement Internationale": "International Payment",
      "Paiement Nationale": "National Payment",
      "Applications & Logiciels": "Apps & Software",
      "Documents éducatifs": "Educational Documents",
      "Certificats & Attestations": "Certificates & Attestations",
      "Documents administratifs": "Administrative Documents",
      "Paiement en ligne": "Online Payment",
      "Cours en ligne": "Online Courses",
      "Outils de productivité": "Productivity Tools"
    },
    footer: {
      brand_desc: "Votre partenaire de confiance pour tous vos services numériques. Recharge mobile, abonnements, et plus encore.",
      rating: {
        excellent: "Excellent",
        based_on: "based on"
      },
      sections: {
        navigation: "Navigation",
        legal: "Legal",
        newsletter: "Newsletter"
      },
      links: {
        faq: "FAQ",
        terms: "Terms & Conditions",
        privacy: "Privacy Policy",
        refund: "Refund Policy",
        delivery: "Delivery Policy",
        legal_notice: "Legal Notice",
        cookies: "Cookie Policy",
        terms_desc: "Consultez nos conditions d\\",
        privacy_desc: "Découvrez comment nous protégeons vos données personnelles et vos droits en matière de confidentialité",
        refund_desc: "Informations détaillées sur les conditions de remboursement, garanties et procédures de retour",
        delivery_desc: "Délais de livraison, frais, zones de livraison et suivi de commande",
        legal_notice_desc: "Informations légales et réglementaires sur l\\",
        cookies_desc: "Informations sur l\\",
        rate_limiting: "Usage limits and security",
        rate_limiting_desc: "Request limit policies (OTP, registration) and temporary blocks.",
        faq_desc: "Questions fréquemment posées et réponses sur nos services"
      },
      newsletter: {
        desc: "Restez informé de nos dernières actualités",
        placeholder: "Your email",
        btn: {
          subscribe: "Subscribe",
          loading: "Envoi...",
          success: "Subscribed!"
        },
        error: "Une erreur est survenue",
        disclaimer: "We respect your privacy. Unsubscribe at any time."
      },
      download_app: {
        title: "Download the app",
        cta: "Get it on Google Play",
        apple: "Download on the App Store"
      },
      copyright: "Tous droits réservés",
      legal: {
        view_all: "Consultez tous nos documents politiques"
      }
    },
    about: {
      title: "About",
      subtitle: "Your trusted partner for a simpler digital life in Tunisia.",
      mission_title: "Our Mission",
      mission_desc: "At EServices.tn, our mission is to simplify the digital life of Tunisian users. We have created a centralized and intuitive platform to give you instant access to a wide range of essential services, from mobile top‑ups to digital subscriptions, as well as the creation of personalized documents. We are committed to making every interaction as smooth and enjoyable as possible.",
      values_title: "Our Values",
      values: {
        reliability: {
          title: "Reliability",
          desc: "We guarantee secure transactions and services delivered on time, every time."
        },
        speed: {
          title: "Speed",
          desc: "Our platform is optimized to offer you an ultra‑fast experience, from order to delivery."
        },
        accessibility: {
          title: "Accessibility",
          desc: "We design our services to be simple and accessible to everyone, wherever you are in Tunisia."
        },
        innovation: {
          title: "Innovation",
          desc: "We constantly strive to improve and expand our offering to meet the evolving needs of our customers."
        }
      },
      quote: "At EServices.tn, we place customer satisfaction at the heart of everything we do."
    },
    AboutPage: {
      header: {
        logo: "eServices"
      },
      team: {
        imageAlt: "Our Team"
      },
      mission: {
        quote: "Innovating to make digital accessible to every Tunisian."
      }
    },
    MobileAboutPage: {
      header: {
        logo: "eServices"
      },
      team: {
        imageAlt: "Our Team"
      },
      mission: {
        quote: "Innovate to make digital accessible to every Tunisian."
      }
    },
    MobileSecurity: {
      header: {
        title: "Security"
      },
      password: {
        changeTitle: "Change password",
        changeDesc: "Update your password regularly",
        cancel: "Cancel",
        edit: "Edit",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        placeholder: "••••••••",
        hide: "Hide",
        show: "Show",
        minChars: "Minimum 6 characters",
        forgotPassword: "Forgot password?",
        updateButton: "Update password",
        changingInProgress: "Updating...",
        errorAllRequired: "All fields are required",
        errorMinLength: "The new password must be at least 6 characters",
        errorMismatch: "Passwords do not match",
        errorSameAsOld: "The new password must be different from the current one",
        errorCurrentIncorrect: "Current password is incorrect",
        errorUpdate: "Error while changing password",
        successUpdated: "Password updated successfully"
      },
      tips: {
        title: "Security tips",
        item1: "Use a strong, unique password",
        item2: "Change your password regularly",
        item3: "Never share your password"
      },
      twoFa: {
        title: "Two-factor authentication",
        disabledDesc: "Extra protection for your account",
        enableButton: "Enable 2FA",
        enabledLabel: "Protection enabled",
        enabledOn: "Enabled on",
        enabledBadge: "Enabled",
        enabledMessage: "Your account is protected by two-factor authentication. You will need to enter a verification code each time you sign in.",
        actionsLabel: "Actions",
        regenerateCodes: "Regenerate recovery codes",
        regenerateCodesDesc: "Generate new backup codes",
        disableButton: "Disable 2FA",
        disableButtonDesc: "Remove extra protection",
        setup: {
          title: "Google Authenticator setup",
          step1Title: "Step 1: Add to Google Authenticator",
          step1_1: "Open Google Authenticator on your phone",
          step1_2: "Tap \"+\" to add an account",
          step1_3: "Select \"Enter a setup key\"",
          step2Title: "Step 2: Enter the secret key",
          secretWarning: "IMPORTANT: Enter the key with NO dashes, spaces or separators",
          secretNote: "Type: Time-based | Algorithm: SHA1",
          step3Title: "Step 3: Verify the code",
          codePlaceholder: "000000"
        },
        verify: "Verify and enable",
        recoveryCodes: {
          title: "Recovery codes",
          warning: "IMPORTANT: Save these codes in a safe place. They will not be shown again.",
          saved: "I have saved the codes"
        },
        disable: {
          title: "Disable 2FA",
          warning: "For security reasons, please confirm your password to disable 2FA.",
          success: "2FA disabled successfully",
          inProgress: "Disabling...",
          confirm: "Disable"
        },
        errorGenerate: "Error generating secret",
        errorCode6Digits: "Please enter a 6-digit code",
        errorCodeIncorrect: "Incorrect code. Please try again.",
        errorVerify: "Error verifying code",
        errorPasswordRequired: "Please enter your password",
        errorDisable: "Error disabling 2FA",
        errorRegenerate: "Error regenerating codes"
      }
    },
    MobileFavorites: {
      header: {
        title: "My Favorites",
        subtitle: "Find the items you liked."
      },
      state: {
        loading: "Loading..."
      },
      empty: {
        title: "No favorites",
        description: "Browse the catalog and add items to your favorites."
      }
    },
    MobileManageDeposits: {
      header: {
        title: "Deposit Management"
      },
      confirm: {
        refuse: "Are you sure you want to refuse this deposit?",
        validate: "Validate this deposit of {{amount}}?"
      },
      filters: {
        pending: "Pending",
        validated: "Validated",
        refused: "Refused",
        all: "All"
      },
      card: {
        amount: "Amount",
        method: "Method",
        proofLabel: "Payment proof",
        viewImage: "View image",
        viewCode: "View code",
        proofAlt: "Deposit proof",
        imageUnavailable: "Image unavailable",
        clickToViewCode: "Click to view full code"
      },
      actions: {
        validate: "Validate",
        refuse: "Refuse"
      },
      empty: {
        title: "No deposits",
        pending: "No deposits pending validation.",
        noMatch: "No deposits found for this filter."
      },
      modal: {
        proofTitle: "Payment proof",
        codeTitle: "Transaction code",
        openFullScreen: "Open full screen",
        copied: "Copied",
        copy: "Copy",
        close: "Close"
      },
      error: "Error"
    },
    Wallet: {
      card: {
        revenue: "Revenue",
        myBalance: "My Balance",
        recharge: "Top up"
      },
      stats: {
        depositsThisMonth: "Deposits this month",
        spendingThisMonth: "Spending this month"
      },
      section: {
        depositManagement: "Deposit management",
        transactionHistory: "Transaction history",
        pendingCount: "{{count}} pending"
      },
      list: {
        rechargeVia: "Top-up via {{method}}"
      },
      empty: {
        noDeposits: "No deposits found"
      },
      modal: {
        stepAmount: "Deposit amount",
        stepMethod: "Payment method",
        stepInstructions: "Complete deposit",
        customAmount: "Custom amount",
        placeholderAmount: "0.000",
        continue: "Continue",
        chooseMethod: "Choose a method",
        submitting: "Processing...",
        submitDeposit: "Submit deposit"
      },
      instructions: {
        title: "Payment Instructions",
        portefeuilleIntro: "Open the app indicated by the seller and send {{amount}} TND to the identifier below.",
        flouciStep1: "Open the Flouci app and send {{amount}} TND",
        d17Step1: "Open the D17 app and send the amount",
        iziStep1: "Open the IZI Pay app and send {{amount}} TND",
        transactionIdLabel: "2. Enter the transaction ID",
        transactionIdPlaceholder: "Transaction ID",
        bankTransferTitle: "Bank transfer",
        bankTransferStep1: "1. Transfer {{amount}} TND to one of the accounts below:",
        rib: "RIB:",
        iban: "IBAN:",
        accountHolder: "Account holder:",
        proofLabel: "2. Payment proof (upload proof file)"
      },
      success: {
        depositSubmitted: "Deposit submitted successfully!"
      },
      error: {
        submitError: "Error submitting. Please try again."
      },
      methods: {
        portefeuille: "Mobile wallet",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "Bank Transfer"
      }
    },
    hardcoded: {
      notre_quipe: "Notre Équipe",
      profil_administrateur: "Profil Administrateur",
      avatar: "Avatar",
      chargement_du_profil_: "Chargement du profil...",
      pr_nom: "Prénom",
      email: "Email",
      t_l_phone: "Téléphone",
      adresse: "Adresse",
      preuve: "Preuve",
      scanner_le_stockage: "Scanner le stockage",
      sync_: "Sync?",
      invit_: "INVITÉ",
      nom: "Nom",
      mot_de_passe: "Mot de passe",
      activit_: "Activité",
      actions: "Actions",
      chargement_: "Chargement...",
      aucun_client_trouv_: "Aucun client trouvé.",
      analyse_des_: "Analyse des بيانات في دور المعالجة...",
      forcer_la_suppression_effacera_d_finitivement_tout: "Forcer la suppression effacera définitivement tout l'historique lié.",
      aucune_donn_e_li_e_trouv_e_la_suppression_est_sans: "Aucune donnée liée trouvée. La suppression est sans risque.",
      nouveau_client: "Nouveau client",
      annuler: "Annuler",
      cr_er_le_compte: "Créer le compte",
      logo_light: "Logo Light",
      logo_dark: "Logo Dark",
      logo_mode_clair_: "Logo (Mode Clair)",
      ce_logo_s_affichera_sur_les_fonds_clairs_ex_th_me_: "Ce logo s'affichera sur les fonds clairs (ex: Thème Light).",
      logo_mode_sombre_: "Logo (Mode Sombre)",
      ce_logo_s_affichera_sur_les_fonds_sombres_ex_th_me: "Ce logo s'affichera sur les fonds sombres (ex: Thème Dark).",
      utiliser_le_th_me_sombre: "Utiliser le thème sombre",
      garder_la_barre_de_recherche_visible_lors_du_d_fil: "Garder la barre de recherche visible lors du défilement (Services).",
      activer_la_barre_fixe: "Activer la barre fixe",
      choisir_la_langue_de_l_interface_: "Choisir la langue de l'interface.",
      fran_ais: "Français",
      english: "English",
      inscription: "Inscription",
      utilisateur_introuvable_: "Utilisateur introuvable.",
      enregistrer: "Enregistrer",
      solde: "Solde",
      actions_rapides: "Actions rapides",
      supprimer_client: "Supprimer Client",
      analyse_de_l_historique_: "Analyse de l'historique...",
      forcer_la_suppression_effacera_tout_l_historique_d: "Forcer la suppression effacera tout l'historique de manière définitive.",
      aucune_donn_e_li_e_trouv_e_suppression_s_curis_e_: "Aucune donnée liée trouvée. Suppression sécurisée.",
      g_rer_le_solde: "Gérer le Solde",
      valider: "Valider",
      offerts: "Offerts",
      ttc_livraison_comprise: "TTC / Livraison comprise",
      paiement_100_s_curis_: "Paiement 100% sécurisé",
      validation_sous_10_30_minutes: "Validation sous 10-30 minutes",
      images_pdf_max_5mb_: "Images, PDF (MAX 5MB)",
      articles_livraison: "Articles & Livraison",
      codes_assign_s_: "Codes assignés :",
      documents_administratifs: "Documents administratifs",
      facture_officielle: "Facture officielle",
      barre_de_filtre_fixe: "Barre de filtre fixe",
      actualiser_la_liste: "Actualiser la liste",
      livraison_automatique_en_attente: "Livraison automatique en attente",
      v_rifier_mes_commandes: "Vérifier mes commandes",
      ouvrir_un_ticket_d_aide: "Ouvrir un ticket d'aide",
      passer_une_commande: "Passer une Commande",
      cat_gories: "Catégories",
      votre_commande: "Votre Commande",
      votre_panier_est_vide_: "Votre panier est vide.",
      s_lectionnez_une_cat_gorie_pour_commencer_: "Sélectionnez une catégorie pour commencer.",
      total: "Total",
      mode_de_paiement: "Mode de paiement",
      note_: "Note :",
      choisir_une_m_thode_: "Choisir une méthode...",
      veuillez_uploader_une_capture_d_cran_ou_un_re_u_po: "Veuillez uploader une capture d'écran ou un reçu pour valider la transaction.",
      mon_profil: "Mon Profil",
      informations_personnelles: "Informations Personnelles",
      changer: "Changer",
      votre_nom: "Votre nom",
      probl_me_commande: "Problème Commande",
      email_de_contact_optionnel_: "Email de contact (optionnel)",
      nom_de_contact_optionnel_: "Nom de contact (optionnel)",
      ticket_non_trouv_: "Ticket non trouvé.",
      lien_de_r_cup_ration_s_curis_: "Lien de récupération sécurisé",
      email_envoy_instantan_ment: "Email envoyé instantanément",
      envoi_en_cours_: "Envoi en cours...",
      envoyer_le_lien_de_r_cup_ration: "Envoyer le lien de récupération",
      chrome_: "Chrome :",
      firefox_: "Firefox :",
      safari_: "Safari :",
      edge_: "Edge :",
      a_cookie_is_a_small_text_file_stored_on_your_devic: "A cookie is a small text file stored on your device (computer, tablet, smartphone) when you visit a website. Cookies allow the site to remember your actions and preferences over a period of time.",
      enhance_your_user_experience_and_personalize_the_i: "Enhance your user experience and personalize the interface",
      ensure_the_technical_functioning_of_the_site_login: "Ensure the technical functioning of the site (login, cart management, transaction security)",
      analyze_site_traffic_and_audience_to_optimize_our_: "Analyze site traffic and audience to optimize our services",
      remember_your_preferences_language_dark_mode_displ: "Remember your preferences (language, dark mode, display settings)",
      protect_the_platform_against_fraudulent_activities: "Protect the platform against fraudulent activities",
      tunisian_law_no_2018_20: "Tunisian Law No. 2018-20",
      essential_cookies_technical_: "Essential Cookies (Technical)",
      indispensable_for_platform_functionality_: "Indispensable for platform functionality:",
      user_authentication_and_session_management: "User authentication and session management",
      maintaining_account_and_transaction_security: "Maintaining account and transaction security",
      preserving_items_in_your_cart_between_sessions: "Preserving items in your cart between sessions",
      remembering_your_privacy_preferences: "Remembering your privacy preferences",
      these_cookies_cannot_be_disabled_via_our_interface: "These cookies cannot be disabled via our interface.",
      analytical_cookies_statistical_: "Analytical Cookies (Statistical)",
      we_use_internal_analytics_tools_to_: "We use internal analytics tools to:",
      measure_audience_and_site_performance: "Measure audience and site performance",
      understand_how_users_interact_with_the_platform: "Understand how users interact with the platform",
      detect_and_resolve_technical_issues: "Detect and resolve technical issues",
      continuously_improve_user_experience: "Continuously improve user experience",
      these_cookies_are_anonymized_and_do_not_allow_pers: "These cookies are anonymized and do not allow personal identification.",
      preference_cookies: "Preference Cookies",
      they_remember_your_personal_choices_: "They remember your personal choices:",
      interface_language_french_arabic_english_: "Interface language (French, Arabic, English)",
      display_mode_dark_light_: "Display mode (dark/light)",
      regional_settings: "Regional settings",
      notification_preferences: "Notification preferences",
      some_services_integrated_into_eservices_may_deposi: "Some services integrated into eServices may deposit their own cookies:",
      payment_services_: "Payment Services:",
      analytics_tools_: "Analytics Tools:",
      transactional_email_services_: "Transactional Email Services:",
      we_carefully_select_our_partners_and_ensure_they_c: "We carefully select our partners and ensure they comply with data protection standards. These cookies are subject to the privacy policies of their issuers.",
      you_have_control_over_cookie_usage_: "You have control over cookie usage:",
      via_our_consent_banner: "Via Our Consent Banner",
      during_your_first_visit_a_banner_allows_you_to_acc: "During your first visit, a banner allows you to accept or refuse non-essential cookies. You can modify your choices at any time by clicking the \"Manage Cookies\" link at the bottom of the page.",
      via_your_browser_settings: "Via Your Browser Settings",
      you_can_configure_your_browser_to_: "You can configure your browser to:",
      refuse_all_cookies: "Refuse all cookies",
      accept_only_essential_cookies: "Accept only essential cookies",
      be_notified_each_time_a_cookie_is_deposited: "Be notified each time a cookie is deposited",
      automatically_delete_cookies_upon_closing: "Automatically delete cookies upon closing",
      the_procedure_varies_by_browser_: "The procedure varies by browser:",
      consequences_of_refusal: "Consequences of Refusal",
      if_you_disable_cookies_: "If you disable cookies:",
      you_will_need_to_log_in_on_each_visit: "You will need to log in on each visit",
      your_cart_will_not_be_saved_between_sessions: "Your cart will not be saved between sessions",
      your_preferences_language_dark_mode_will_not_be_re: "Your preferences (language, dark mode) will not be remembered",
      some_features_may_be_limited: "Some features may be limited",
      security_of_certain_transactions_may_be_reduced: "Security of certain transactions may be reduced",
      cookies_have_varying_lifespans_: "Cookies have varying lifespans:",
      session_cookies_: "Session Cookies:",
      persistent_cookies_: "Persistent Cookies:",
      authentication_cookies_: "Authentication Cookies:",
      analytical_cookies_: "Analytical Cookies:",
      privacy_policy: "Privacy Policy",
      data_collected_via_cookies_is_processed_securely: "Data collected via cookies is processed securely",
      we_do_not_share_your_browsing_data_for_commercial_: "We do not share your browsing data for commercial purposes without your consent",
      analytical_cookies_are_anonymized: "Analytical cookies are anonymized",
      we_retain_technical_logs_related_to_cookies_for_a_: "We retain technical logs related to cookies for a maximum of 1 year",
      you_have_the_right_to_access_rectify_and_object_to: "You have the right to access, rectify, and object to the processing of your data",
      we_may_update_this_cookie_policy_to_reflect_: "We may update this Cookie Policy to reflect:",
      technical_evolution_of_the_platform: "Technical evolution of the platform",
      tunisian_or_international_regulatory_changes: "Tunisian or international regulatory changes",
      addition_of_new_features_or_services: "Addition of new features or services",
      changes_will_be_published_on_this_page_with_the_up: "Changes will be published on this page with the update date. In case of significant changes, we will inform you via email or platform notification.",
      for_any_questions_regarding_our_use_of_cookies_or_: "For any questions regarding our use of cookies or to exercise your rights:",
      dpo_email_: "DPO Email:",
      support_tickets_: "Support Tickets:",
      postal_address_: "Postal Address:",
      national_authority_for_personal_data_protection_in: "National Authority for Personal Data Protection (INPDP)",
      last_updated_: "Last Updated:",
      version_: "Version :",
      applicable_to_: "Applicable to:",
      my_codes: "My Codes",
      reveal: "Reveal",
      article_1_scope: "ARTICLE 1 - SCOPE",
      digital_services: "Digital Services",
      article_2_digital_services_top_ups_codes_subscript: "ARTICLE 2 - DIGITAL SERVICES (Top-ups, Codes, Subscriptions)",
      mobile_top_up_: "Mobile Top-up:",
      digital_codes_gaming_streaming_licenses_: "Digital Codes (Gaming, Streaming, Licenses):",
      masked_code_: "Masked Code:",
      pdf_export_: "PDF Export:",
      article_3_customized_and_physical_products: "ARTICLE 3 - CUSTOMIZED AND PHYSICAL PRODUCTS",
      processing_: "Processing:",
      shipped_: "Shipped:",
      delivered_: "Delivered:",
      preparation_: "Preparation:",
      transport_: "Transport :",
      article_4_responsibilities: "ARTICLE 4 - RESPONSIBILITIES",
      risk_on_physical_products_: "Risk on Physical Products:",
      digital_service_not_received_: "Digital Service Not Received:",
      customization_files_: "Customization Files:",
      article_5_delivery_address: "ARTICLE 5 - DELIVERY ADDRESS",
      article_6_right_of_withdrawal: "ARTICLE 6 - RIGHT OF WITHDRAWAL",
      digital_services_provided_immediately_after_the_or: "Digital services provided immediately after the order (top-ups, delivered codes)",
      goods_made_to_the_customer_s_specifications_or_cle: "Goods made to the Customer's specifications or clearly personalized",
      perishable_products_or_products_with_a_limited_val: "Perishable products or products with a limited validity date",
      refund_policy: "Refund Policy",
      response_time_: "Response time:",
      publishing_company: "Publishing Company",
      company_name_: "Company Name:",
      legal_form_: "Legal Form:",
      share_capital_: "Share capital:",
      registration_: "Registration:",
      vat_number_: "VAT number:",
      headquarters: "Headquarters",
      address_: "Address:",
      location_: "Location:",
      management_and_publication: "Management and Publication",
      publication_director_: "Publication director:",
      editorial_manager_: "Editorial Manager:",
      data_protection_officer_: "Data Protection Officer:",
      technical_and_commercial_support: "Technical and Commercial Support",
      email_: "Email :",
      phone_: "Phone:",
      business_hours_: "Business Hours:",
      monday_to_friday_9_am_6_pm_tunisian_local_time_: "Monday to Friday, 9 AM - 6 PM (Tunisian local time)",
      recommendation_: "Recommendation:",
      legal_and_compliance_services: "Legal and Compliance Services",
      legal_email_: "Legal Email:",
      data_protection_: "Data Protection:",
      dispute_service_: "Dispute Service:",
      main_infrastructure: "Main Infrastructure",
      database_and_authentication: "Database and Authentication",
      provider_: "Provider:",
      security_: "Security:",
      certifications_: "Certifications :",
      complementary_services: "Complementary Services",
      transactional_email_: "Transactional Email:",
      audience_analysis_: "Audience Analysis:",
      monitoring_: "Monitoring :",
      cdn_: "CDN :",
      availability_and_maintenance: "Availability and Maintenance",
      guaranteed_uptime_rate: "Guaranteed uptime rate",
      monitoring_and_technical_support: "Monitoring and technical support",
      certified_tls_1_3_encryption: "Certified TLS 1.3 encryption",
      trademarks_and_logos: "Trademarks and Logos",
      registration_with_innorpi_national_institute_of_st: "Registration with INNORPI (National Institute of Standardization and Industrial Property)",
      international_protection_via_the_madrid_system: "International protection via the Madrid System",
      any_reproduction_without_express_authorization_is_: "Any reproduction without express authorization is prohibited",
      copyright: "Copyright",
      source_code_and_algorithms: "Source code and algorithms",
      design_and_user_interface: "Design and user interface",
      technical_documentation_and_editorial_content: "Technical documentation and editorial content",
      database_sui_generis_protection_: "Database (sui generis protection)",
      exception_: "Exception :",
      usage_licenses: "Usage Licenses",
      allowed: "Allowed",
      personal_and_non_commercial_use: "Personal and non-commercial use",
      access_via_browser_or_official_application: "Access via browser or official application",
      creation_of_a_single_account_per_person: "Creation of a single account per person",
      prohibited: "Prohibited",
      reverse_engineering_or_decompilation: "Reverse engineering or decompilation",
      unauthorized_commercial_use: "Unauthorized commercial use",
      creation_of_multiple_accounts: "Creation of multiple accounts",
      mass_data_extraction: "Mass data extraction",
      domain: "Domain",
      legal_framework: "Legal Framework",
      compliance: "Compliance",
      reference: "Reference",
      e_commerce: "E-commerce",
      tunisian_law_no_2000_83: "Tunisian Law No. 2000-83",
      full: "Full",
      articles_54_55: "Articles 54-55",
      data_protection: "Data Protection",
      organic_law_no_2018_20: "Organic Law No. 2018-20",
      inpdp_declaration: "INPDP Declaration",
      file_no_number_: "File No. [Number]",
      payment_services: "Payment Services",
      bct_regulation: "BCT Regulation",
      compliant_with_practices: "Compliant with practices",
      circular_xx_2022: "Circular XX/2022",
      consumption: "Consumption",
      consumer_protection_code: "Consumer Protection Code",
      respect_of_deadlines: "Respect of deadlines",
      articles_35_42: "Articles 35-42",
      taxation: "Taxation",
      customs_and_tax_code: "Customs and Tax Code",
      vat_collected: "VAT collected",
      vat_no_vat_number_: "VAT No: [VAT Number]",
      law_no_94_36: "Law No. 94-36",
      partner_licenses: "Partner licenses",
      innorpi: "INNORPI",
      regulatory_authorities: "Regulatory Authorities",
      inpdp: "INPDP",
      national_authority_for_the_protection_of_personal_: "National Authority for the Protection of Personal Data",
      central_bank_of_tunisia: "Central Bank of Tunisia",
      national_institute_of_standardization_and_industri: "National Institute of Standardization and Industrial Property",
      intermediary_role: "Intermediary Role",
      important_: "Important :",
      warranty_exclusions: "Warranty Exclusions",
      digital_services_: "Digital Services:",
      service_interruptions_: "Service Interruptions:",
      user_data_: "User Data:",
      fraudulent_use_: "Fraudulent Use:",
      liability_cap: "Liability Cap",
      order_amount: "Order Amount",
      cap_for_digital_services: "Cap for digital services",
      last_deposit: "Last Deposit",
      cap_for_processing_errors: "Cap for processing errors",
      applicable_law: "Applicable Law",
      tunisian_law: "Tunisian law",
      competent_courts: "Competent Courts",
      amicable_settlement: "Amicable Settlement",
      mediation: "Mediation",
      modification_notification: "Modification Notification",
      publication_on_this_page_with_update_date_indicati: "Publication on this page with update date indication",
      email_notification_to_active_users: "Email notification to active users",
      display_of_an_information_banner_in_the_applicatio: "Display of an information banner in the application",
      effective_date: "Effective Date",
      general_terms: "General Terms",
      tunisian_organic_law_no_2018_20_of_april_25_2018: "Tunisian Organic Law No. 2018-20 of April 25, 2018",
      data_controller_: "Data Controller:",
      data_protection_officer_dpo_: "Data Protection Officer (DPO):",
      when_you_use_our_platform_we_may_collect_the_follo: "When you use our platform, we may collect the following categories of data:",
      identification_data: "Identification Data",
      first_and_last_name: "First and last name",
      email_address: "Email address",
      tunisian_mobile_phone_number: "Tunisian mobile phone number",
      delivery_address_for_physical_products_: "Delivery address (for physical products)",
      financial_data: "Financial Data",
      deposit_history_amount_method_anonymized_payment_p: "Deposit history (amount, method, anonymized payment proof)",
      order_history_and_internal_balance_deductions: "Order history and Internal Balance deductions",
      electronic_invoices: "Electronic invoices",
      user_content_data: "User Content Data",
      files_uploaded_for_product_customization: "Files uploaded for product customization",
      avatar_and_profile_preferences: "Avatar and profile preferences",
      technical_data: "Technical Data",
      ip_address_and_connection_logs: "IP address and connection logs",
      device_type_browser_and_operating_system: "Device type, browser and operating system",
      preferences_language_dark_mode_: "Preferences (language, dark mode)",
      navigation_data_via_cookies: "Navigation data via cookies",
      your_data_is_processed_based_on_legal_grounds_defi: "Your data is processed based on legal grounds defined by Tunisian law:",
      purpose: "Purpose",
      legal_basis_law_2018_20_: "Legal Basis (Law 2018-20)",
      details: "Details",
      account_and_internal_balance_management: "Account and Internal Balance Management",
      contract_performance_art_13_: "Contract performance (Art. 13)",
      creation_of_eservices_wallet_deposit_validation_ba: "Creation of eServices Wallet, deposit validation, balance tracking, authentication",
      order_processing: "Order Processing",
      delivery_of_digital_codes_product_customization_in: "Delivery of digital codes, product customization, invoicing, after-sales support",
      payment_proof_archiving: "Payment Proof Archiving",
      legal_obligation_art_15_: "Legal obligation (Art. 15)",
      retention_of_financial_records_according_to_tunisi: "Retention of financial records according to Tunisian Commercial Code (10 years)",
      fraud_prevention: "Fraud Prevention",
      legitimate_interest_art_14_: "Legitimate interest (Art. 14)",
      behavior_analysis_to_secure_the_platform_and_prote: "Behavior analysis to secure the platform and protect our users",
      customer_support_improvement: "Customer Support & Improvement",
      responding_to_requests_via_tickets_improving_inter: "Responding to requests via tickets, improving interface and services",
      marketing_newsletters_: "Marketing (Newsletters)",
      explicit_consent_art_12_: "Explicit consent (Art. 12)",
      only_if_you_checked_the_acceptance_box_during_regi: "Only if you checked the acceptance box during registration",
      supabase_inc_: "Supabase Inc.",
      transactional_email_services: "Transactional email services",
      shipping_providers: "Shipping providers",
      retention_periods: "Retention Periods",
      active_account_data: "Active account data",
      transactional_data_and_invoices: "Transactional data and invoices",
      uploaded_customization_files: "Uploaded customization files",
      security_logs: "Security logs",
      deletion_procedure: "Deletion Procedure",
      anonymized: "Anonymized",
      securely_destroyed: "Securely destroyed",
      right_of_access: "Right of Access",
      obtain_confirmation_that_your_data_is_being_proces: "Obtain confirmation that your data is being processed and receive a copy.",
      right_to_rectification: "Right to Rectification",
      have_inaccurate_or_incomplete_data_corrected_: "Have inaccurate or incomplete data corrected.",
      right_to_erasure: "Right to Erasure",
      request_deletion_of_your_data_under_certain_condit: "Request deletion of your data under certain conditions.",
      right_to_restriction: "Right to Restriction",
      temporarily_suspend_processing_of_your_data_: "Temporarily suspend processing of your data.",
      right_to_object: "Right to Object",
      object_to_processing_for_legitimate_reasons_: "Object to processing for legitimate reasons.",
      right_to_data_portability: "Right to Data Portability",
      receive_your_data_in_a_structured_commonly_used_fo: "Receive your data in a structured, commonly used format.",
      how_to_exercise_your_rights_: "How to Exercise Your Rights?",
      technical_measures: "Technical Measures",
      ssl_tls_encryption_for_all_communications: "SSL/TLS encryption for all communications",
      firewalls_and_intrusion_detection_systems: "Firewalls and intrusion detection systems",
      regular_encrypted_backups: "Regular encrypted backups",
      passwords_stored_in_hashed_form_bcrypt_: "Passwords stored in hashed form (bcrypt)",
      two_factor_authentication_for_administrative_team: "Two-factor authentication for administrative team",
      organizational_measures: "Organizational Measures",
      restricted_data_access_based_on_need_to_know_princ: "Restricted data access based on \"need-to-know\" principle",
      mandatory_staff_training_on_data_protection: "Mandatory staff training on data protection",
      regular_security_audits: "Regular security audits",
      documented_procedures_in_case_of_data_breach: "Documented procedures in case of data breach",
      breach_notification: "Breach Notification",
      cookie_type: "Cookie Type",
      retention: "Retention",
      essential_cookies: "Essential Cookies",
      maintain_your_login_session_manage_your_cart_ensur: "Maintain your login session, manage your cart, ensure security",
      session_duration: "Session duration",
      analytical_cookies: "Analytical Cookies",
      measure_audience_understand_platform_usage_anonymi: "Measure audience, understand platform usage (anonymized)",
      maximum_13_months: "Maximum 13 months",
      remember_your_language_dark_light_mode: "Remember your language, dark/light mode",
      european_commission_standard_contractual_clauses: "European Commission Standard Contractual Clauses",
      data_protection_certifications_e_g_privacy_shield_: "Data protection certifications (e.g., Privacy Shield for the United States, when applicable)",
      strict_confidentiality_agreements_with_our_subcont: "Strict confidentiality agreements with our subcontractors",
      effective_date_: "Effective Date:",
      general_email_: "General email:",
      deposit_issue: "Deposit issue",
      non_functional_code: "Non-functional code",
      service_discontinued: "Service discontinued",
      terms_and_conditions_of_use: "Terms and Conditions of Use",
      important_note_: "Important note:",
      article_1_general_principle_no_refund: "ARTICLE 1 - GENERAL PRINCIPLE: NO REFUND",
      the_eservices_internal_balance_is_non_refundable_: "The eServices Internal Balance is non-refundable.",
      article_2_exceptional_cases_for_credit_or_refund: "ARTICLE 2 - EXCEPTIONAL CASES FOR CREDIT OR REFUND",
      status_pending_: "Status \"Pending\":",
      status_validated_: "Status \"Validated\":",
      exception_for_double_bank_transfer_: "Exception for double bank transfer:",
      timeframe_: "Timeframe:",
      verification_: "Verification:",
      solution_: "Solution :",
      article_3_procedure_for_admitted_exceptional_cases: "ARTICLE 3 - PROCEDURE FOR ADMITTED EXCEPTIONAL CASES",
      open_a_support_ticket: "Open a support ticket",
      provide_all_necessary_evidence_: "Provide all necessary evidence:",
      complete_screenshots: "Complete screenshots",
      transaction_identification_number_d17_flouci_: "Transaction identification number (D17/Flouci)",
      bank_transfer_proof: "Bank transfer proof",
      relevant_order_number: "Relevant order number",
      request_review_: "Request review:",
      decision_and_compensation_: "Decision and compensation:",
      article_4_applicable_fees: "ARTICLE 4 - APPLICABLE FEES",
      no_fees: "No Fees",
      processing_a_replacement_credit_request_defective_: "Processing a replacement credit request (defective code) is free of charge.",
      bank_transaction_fees: "Bank Transaction Fees",
      article_5_contact_and_processing_modalities: "ARTICLE 5 - CONTACT AND PROCESSING MODALITIES",
      the_ticket_system_ensures_organized_follow_up_secu: "The ticket system ensures organized follow-up, secure exchanges, and the ability to attach supporting documents.",
      you_can_track_the_progress_of_your_request_at_any_: "You can track the progress of your request at any time from your interface.",
      related_documents: "Related documents",
      delivery_policy: "Delivery Policy",
      last_updated_date_: "Last updated date:",
      publisher: "Publisher",
      legal_name_: "Legal name:",
      registered_office_: "Registered office:",
      legal_contact_: "Legal contact:",
      art_1_purpose: "Art 1. Purpose",
      these_general_terms_and_conditions_gtc_aim_to_defi: "These General Terms and Conditions (GTC) aim to define the rights and obligations of the parties within the framework of using the eServices platform and its economic model based on a prepaid internal balance. They govern access to the website eservices.tn and the associated mobile application, the creation of the eServices Wallet account, deposit of funds, and the purchase of digital services and customized products.",
      art_2_definitions: "Art 2. Definitions",
      platform_: "Platform:",
      user_client_: "User/Client:",
      account_eservices_wallet_: "Account / eServices Wallet:",
      internal_balance_: "Internal Balance:",
      services_: "Services :",
      deposit_: "Deposit:",
      order_: "Order:",
      art_3_acceptance_and_capacity: "Art 3. Acceptance and Capacity",
      art_4_service_description_and_role_of_eservices: "Art 4. Service Description and Role of eServices",
      the_management_of_a_prepaid_electronic_wallet_inte: "The management of a prepaid electronic wallet (Internal Balance).",
      the_purchase_of_services_provided_by_third_party_p: "The purchase of Services provided by third-party partners (telecom operators, game publishers, streaming services) or produced by eServices (customization).",
      art_5_account_creation_and_security: "Art 5. Account Creation and Security",
      art_6_internal_balance_top_up_nature_irrevocabilit: "Art 6. Internal Balance: Top-up, Nature, Irrevocability",
      validation_of_the_deposit_is_conditional_upon_rece: "Validation of the Deposit is conditional upon receipt and manual verification by eServices of valid payment proof.",
      the_internal_balance_is_strictly_attached_to_the_a: "The Internal Balance is strictly attached to the Account and cannot be assigned, sold, or transferred to a third party.",
      art_7_order_placement_and_payment: "Art 7. Order Placement and Payment",
      art_8_delivery: "Art 8. Delivery",
      the_right_of_withdrawal_is_excluded_: "The right of withdrawal is excluded.",
      delivery_according_to_the_terms_indicated_on_the_p: "Delivery according to the terms indicated on the product sheet. Delivery times begin after validation of customization by our team. Shipping costs and risks are specified at the time of order.",
      art_9_right_of_withdrawal_and_warranties: "Art 9. Right of Withdrawal and Warranties",
      services_fully_performed_before_the_end_of_the_wit: "Services fully performed before the end of the withdrawal period (top-ups, delivered codes)",
      goods_or_services_whose_price_depends_on_financial: "Goods or services whose price depends on financial market fluctuations",
      goods_made_to_their_specifications_or_clearly_cust: "Goods made to their specifications or clearly customized",
      the_provisions_of_the_tunisian_code_of_obligations: "The provisions of the Tunisian Code of Obligations and Contracts relating to hidden defects remain applicable. For a defective digital code, the Client must open a ticket within 48 hours to obtain a replacement code.",
      art_10_intellectual_property: "Art 10. Intellectual Property",
      the_platform_its_design_source_code_databases_logo: "The Platform, its design, source code, databases, logos, and editorial content are the exclusive property of eServices or its licensors and are protected by Tunisian copyright law and international conventions (INNORPI). Any file uploaded by the Client remains their intellectual property; they grant eServices a limited usage license for the strict execution of the order.",
      art_11_client_obligations_and_responsibilities: "Art 11. Client Obligations and Responsibilities",
      the_client_undertakes_not_to_: "The Client undertakes not to:",
      use_the_platform_for_illegal_or_fraudulent_purpose: "Use the Platform for illegal or fraudulent purposes",
      attempt_to_hack_disassemble_or_overload_the_infras: "Attempt to hack, disassemble, or overload the infrastructure",
      upload_files_containing_viruses_or_illicit_content: "Upload files containing viruses or illicit content",
      bypass_the_internal_balance_system: "Bypass the internal balance system",
      art_12_limitation_of_eservices_s_liability: "Art 12. Limitation of eServices's Liability",
      interruptions_due_to_maintenance_or_force_majeure: "Interruptions due to maintenance or force majeure",
      data_loss_related_to_client_s_fault: "Data loss related to Client's fault",
      content_or_availability_of_services_provided_by_th: "Content or availability of services provided by third-party partners (operators, publishers)",
      indirect_damages_loss_of_profits_loss_of_opportuni: "Indirect damages (loss of profits, loss of opportunity)",
      art_13_personal_data: "Art 13. Personal Data",
      art_14_suspension_and_termination: "Art 14. Suspension and Termination",
      art_15_modifications: "Art 15. Modifications",
      art_16_applicable_law_and_disputes: "Art 16. Applicable Law and Disputes",
      courts_of_registered_office_city_: "Courts of [Registered office city]",
      un_cookie_est_un_petit_fichier_texte_stock_sur_vot: "Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies permettent au site de mémoriser vos actions et préférences sur une période donnée.",
      am_liorer_votre_exp_rience_utilisateur_et_personna: "Améliorer votre expérience utilisateur et personnaliser l'interface",
      assurer_le_fonctionnement_technique_du_site_connex: "Assurer le fonctionnement technique du site (connexion, gestion du panier, sécurité des transactions)",
      analyser_le_trafic_et_l_audience_du_site_pour_opti: "Analyser le trafic et l'audience du site pour optimiser nos services",
      enregistrer_vos_pr_f_rences_langue_mode_sombre_par: "Enregistrer vos préférences (langue, mode sombre, paramètres d'affichage)",
      prot_ger_la_plateforme_contre_les_activit_s_fraudu: "Protéger la plateforme contre les activités frauduleuses",
      loi_tunisienne_n_2018_20: "Loi tunisienne n° 2018-20",
      cookies_essentiels_techniques_: "Cookies essentiels (techniques)",
      indispensables_au_fonctionnement_de_la_plateforme_: "Indispensables au fonctionnement de la plateforme :",
      authentification_et_gestion_de_session_utilisateur: "Authentification et gestion de session utilisateur",
      maintien_de_la_s_curit_de_votre_compte_et_de_vos_t: "Maintien de la sécurité de votre compte et de vos transactions",
      conservation_des_articles_dans_votre_panier_entre_: "Conservation des articles dans votre panier entre les sessions",
      m_morisation_de_vos_pr_f_rences_de_confidentialit_: "Mémorisation de vos préférences de confidentialité",
      ces_cookies_ne_peuvent_pas_tre_d_sactiv_s_via_notr: "Ces cookies ne peuvent pas être désactivés via notre interface.",
      cookies_analytiques_statistiques_: "Cookies analytiques (statistiques)",
      nous_utilisons_des_outils_d_analyse_internes_pour_: "Nous utilisons des outils d'analyse internes pour :",
      mesurer_l_audience_et_les_performances_du_site: "Mesurer l'audience et les performances du site",
      comprendre_comment_les_utilisateurs_interagissent_: "Comprendre comment les utilisateurs interagissent avec la plateforme",
      d_tecter_et_r_soudre_les_probl_mes_techniques: "Détecter et résoudre les problèmes techniques",
      am_liorer_continuellement_l_exp_rience_utilisateur: "Améliorer continuellement l'expérience utilisateur",
      ces_cookies_sont_anonymis_s_et_ne_permettent_pas_v: "Ces cookies sont anonymisés et ne permettent pas votre identification personnelle.",
      cookies_de_pr_f_rences: "Cookies de préférences",
      ils_m_morisent_vos_choix_personnels_: "Ils mémorisent vos choix personnels :",
      langue_de_l_interface_fran_ais_arabe_anglais_: "Langue de l'interface (Français, Arabe, Anglais)",
      mode_d_affichage_sombre_clair_: "Mode d'affichage (sombre/clair)",
      param_tres_r_gionaux: "Paramètres régionaux",
      pr_f_rences_de_notification: "Préférences de notification",
      certains_services_int_gr_s_eservices_peuvent_d_pos: "Certains services intégrés à eServices peuvent déposer leurs propres cookies :",
      services_de_paiement_: "Services de paiement :",
      outils_d_analyse_: "Outils d'analyse :",
      services_d_email_transactionnel_: "Services d'email transactionnel :",
      nous_s_lectionnons_rigoureusement_nos_partenaires_: "Nous sélectionnons rigoureusement nos partenaires et nous assurons qu'ils respectent les standards de protection des données. Ces cookies sont soumis aux politiques de confidentialité de leurs émetteurs.",
      vous_avez_le_contr_le_sur_l_utilisation_des_cookie: "Vous avez le contrôle sur l'utilisation des cookies :",
      via_notre_bandeau_de_consentement: "Via notre bandeau de consentement",
      lors_de_votre_premi_re_visite_un_bandeau_vous_perm: "Lors de votre première visite, un bandeau vous permet d'accepter ou de refuser les cookies non essentiels. Vous pouvez modifier vos choix à tout moment en cliquant sur le lien \"Gérer les cookies\" en bas de page.",
      via_les_param_tres_de_votre_navigateur: "Via les paramètres de votre navigateur",
      vous_pouvez_configurer_votre_navigateur_pour_: "Vous pouvez configurer votre navigateur pour :",
      refuser_tous_les_cookies: "Refuser tous les cookies",
      accepter_uniquement_les_cookies_essentiels: "Accepter uniquement les cookies essentiels",
      _tre_averti_chaque_d_p_t_de_cookie: "Être averti à chaque dépôt de cookie",
      supprimer_automatiquement_les_cookies_la_fermeture: "Supprimer automatiquement les cookies à la fermeture",
      la_proc_dure_varie_selon_les_navigateurs_: "La procédure varie selon les navigateurs :",
      cons_quences_du_refus: "Conséquences du refus",
      si_vous_d_sactivez_les_cookies_: "Si vous désactivez les cookies :",
      vous_devrez_vous_reconnecter_chaque_visite: "Vous devrez vous reconnecter à chaque visite",
      votre_panier_ne_sera_pas_sauvegard_entre_les_sessi: "Votre panier ne sera pas sauvegardé entre les sessions",
      vos_pr_f_rences_langue_mode_sombre_ne_seront_pas_m: "Vos préférences (langue, mode sombre) ne seront pas mémorisées",
      certaines_fonctionnalit_s_pourraient_tre_limit_es: "Certaines fonctionnalités pourraient être limitées",
      la_s_curit_de_certaines_transactions_pourrait_tre_: "La sécurité de certaines transactions pourrait être réduite",
      les_cookies_ont_des_dur_es_de_vie_variables_: "Les cookies ont des durées de vie variables :",
      cookies_de_session_: "Cookies de session :",
      cookies_persistants_: "Cookies persistants :",
      cookies_d_authentification_: "Cookies d'authentification :",
      cookies_analytiques_: "Cookies analytiques :",
      politique_de_confidentialit_: "Politique de Confidentialité",
      les_donn_es_collect_es_via_les_cookies_sont_trait_: "Les données collectées via les cookies sont traitées de manière sécurisée",
      nous_ne_partageons_pas_vos_donn_es_de_navigation_d: "Nous ne partageons pas vos données de navigation à des fins commerciales sans votre consentement",
      les_cookies_analytiques_sont_anonymis_s: "Les cookies analytiques sont anonymisés",
      nous_conservons_les_logs_techniques_li_s_aux_cooki: "Nous conservons les logs techniques liés aux cookies pendant 1 an maximum",
      vous_disposez_d_un_droit_d_acc_s_de_rectification_: "Vous disposez d'un droit d'accès, de rectification et d'opposition au traitement de vos données",
      nous_pouvons_mettre_jour_cette_politique_de_cookie: "Nous pouvons mettre à jour cette Politique de Cookies pour refléter :",
      les_volutions_techniques_de_la_plateforme: "Les évolutions techniques de la plateforme",
      les_changements_r_glementaires_tunisiens_ou_intern: "Les changements réglementaires tunisiens ou internationaux",
      l_ajout_de_nouvelles_fonctionnalit_s_ou_services: "L'ajout de nouvelles fonctionnalités ou services",
      les_modifications_seront_publi_es_sur_cette_page_a: "Les modifications seront publiées sur cette page avec indication de la date de mise à jour. En cas de changement significatif, nous vous en informerons par email ou via une notification sur la plateforme.",
      pour_toute_question_concernant_notre_utilisation_d: "Pour toute question concernant notre utilisation des cookies ou pour exercer vos droits :",
      email_du_dpo_: "Email du DPO :",
      tickets_de_support_: "Tickets de support :",
      adresse_postale_: "Adresse postale :",
      instance_nationale_de_protection_des_donn_es_perso: "Instance Nationale de Protection des Données Personnelles (INPDP)",
      derni_re_mise_jour_: "Dernière mise à jour :",
      applicable_: "Applicable à :",
      mes_codes: "Mes Codes",
      r_v_ler: "Révéler",
      article_1_champ_d_application: "ARTICLE 1 - CHAMP D'APPLICATION",
      services_num_riques: "Services Numériques",
      article_2_services_num_riques_recharges_codes_abon: "ARTICLE 2 - SERVICES NUMÉRIQUES (Recharges, Codes, Abonnements)",
      recharge_mobile_: "Recharge Mobile :",
      codes_num_riques_gaming_streaming_licences_: "Codes Numériques (Gaming, Streaming, Licences) :",
      code_masqu_: "Code Masqué :",
      export_pdf_: "Export PDF :",
      article_3_produits_personnalis_s_et_physiques: "ARTICLE 3 - PRODUITS PERSONNALISÉS ET PHYSIQUES",
      en_traitement_: "En traitement :",
      exp_di_: "Expédié :",
      livr_: "Livré :",
      pr_paration_: "Préparation :",
      article_4_responsabilit_s: "ARTICLE 4 - RESPONSABILITÉS",
      risque_sur_les_produits_physiques_: "Risque sur les Produits Physiques :",
      service_num_rique_non_re_u_: "Service Numérique Non Reçu :",
      fichiers_de_personnalisation_: "Fichiers de Personnalisation :",
      article_5_coordonn_es_de_livraison: "ARTICLE 5 - COORDONNÉES DE LIVRAISON",
      article_6_droit_de_r_tractation: "ARTICLE 6 - DROIT DE RÉTRACTATION",
      les_services_num_riques_fournis_imm_diatement_apr_: "Les services numériques fournis immédiatement après la commande (recharges, codes livrés)",
      les_biens_confectionn_s_selon_ses_sp_cifications_o: "Les biens confectionnés selon ses spécifications ou nettement personnalisés",
      les_produits_p_rissables_ou_ayant_une_date_de_vali: "Les produits périssables ou ayant une date de validité limitée",
      politique_de_remboursement: "Politique de Remboursement",
      d_lai_de_r_ponse_: "Délai de réponse :",
      soci_t_ditrice: "Société éditrice",
      d_nomination_sociale_: "Dénomination sociale :",
      forme_juridique_: "Forme juridique :",
      capital_social_: "Capital social :",
      immatriculation_: "Immatriculation :",
      tva_intracommunautaire_: "TVA Intracommunautaire :",
      si_ge_social: "Siège social",
      adresse_: "Adresse :",
      g_olocalisation_: "Géolocalisation :",
      direction_et_publication: "Direction et publication",
      directeur_de_la_publication_: "Directeur de la publication :",
      responsable_ditorial_: "Responsable éditorial :",
      d_l_gu_la_protection_des_donn_es_: "Délégué à la Protection des Données :",
      support_technique_et_commercial: "Support technique et commercial",
      t_l_phone_: "Téléphone :",
      horaires_: "Horaires :",
      lundi_au_vendredi_9h_18h_heure_locale_tunisienne_: "Lundi au Vendredi, 9h-18h (heure locale tunisienne)",
      recommandation_: "Recommandation :",
      service_juridique_et_conformit_: "Service juridique et conformité",
      email_juridique_: "Email juridique :",
      protection_des_donn_es_: "Protection des données :",
      service_contentieux_: "Service contentieux :",
      infrastructure_principale: "Infrastructure principale",
      base_de_donn_es_et_authentification: "Base de données et authentification",
      fournisseur_: "Fournisseur :",
      localisation_: "Localisation :",
      s_curit_: "Sécurité :",
      services_compl_mentaires: "Services complémentaires",
      email_transactionnel_: "Email transactionnel :",
      analyse_d_audience_: "Analyse d'audience :",
      disponibilit_et_maintenance: "Disponibilité et maintenance",
      taux_de_disponibilit_garanti: "Taux de disponibilité garanti",
      surveillance_et_support_technique: "Surveillance et support technique",
      chiffrement_tls_1_3_certifi_: "Chiffrement TLS 1.3 certifié",
      marques_et_logos: "Marques et logos",
      d_p_t_innorpi_institut_national_de_la_normalisatio: "Dépôt INNORPI (Institut National de la Normalisation et de la Propriété Industrielle)",
      protection_internationale_via_le_syst_me_de_madrid: "Protection internationale via le système de Madrid",
      toute_reproduction_sans_autorisation_expresse_est_: "Toute reproduction sans autorisation expresse est interdite",
      droits_d_auteur: "Droits d'auteur",
      code_source_et_algorithmes: "Code source et algorithmes",
      design_et_interface_utilisateur: "Design et interface utilisateur",
      documentation_technique_et_contenu_ditorial: "Documentation technique et contenu éditorial",
      base_de_donn_es_protection_sui_generis_: "Base de données (protection sui generis)",
      licences_d_utilisation: "Licences d'utilisation",
      autoris_: "Autorisé",
      usage_personnel_et_non_commercial: "Usage personnel et non commercial",
      acc_s_via_navigateur_ou_application_officielle: "Accès via navigateur ou application officielle",
      cr_ation_d_un_compte_unique_par_personne: "Création d'un compte unique par personne",
      interdit: "Interdit",
      reverse_engineering_ou_d_compilation: "Reverse engineering ou décompilation",
      utilisation_commerciale_non_autoris_e: "Utilisation commerciale non autorisée",
      cr_ation_de_comptes_multiples: "Création de comptes multiples",
      extraction_massive_de_donn_es: "Extraction massive de données",
      domaine: "Domaine",
      cadre_l_gal: "Cadre légal",
      conformit_: "Conformité",
      r_f_rence: "Référence",
      commerce_lectronique: "Commerce électronique",
      loi_tunisienne_n_2000_83: "Loi tunisienne n°2000-83",
      compl_te: "Complète",
      protection_des_donn_es: "Protection des données",
      loi_organique_n_2018_20: "Loi organique n°2018-20",
      d_claration_inpdp: "Déclaration INPDP",
      dossier_n_num_ro_: "Dossier n° [Numéro]",
      services_de_paiement: "Services de paiement",
      r_glementation_bct: "Règlementation BCT",
      conforme_aux_usages: "Conforme aux usages",
      circulaire_xx_2022: "Circulaire XX/2022",
      consommation: "Consommation",
      code_de_la_consommation: "Code de la Consommation",
      respect_des_d_lais: "Respect des délais",
      fiscalit_: "Fiscalité",
      code_des_douanes_et_imp_ts: "Code des Douanes et Impôts",
      tva_collect_e: "TVA collectée",
      n_tva_num_ro_tva_: "N° TVA: [Numéro TVA]",
      droit_d_auteur: "Droit d'auteur",
      loi_n_94_36: "Loi n°94-36",
      licences_partenaires: "Licences partenaires",
      autorit_s_de_r_gulation: "Autorités de régulation",
      banque_centrale_de_tunisie: "Banque Centrale de Tunisie",
      institut_national_de_la_normalisation_et_de_la_pro: "Institut National de la Normalisation et de la Propriété Industrielle",
      r_le_d_interm_diaire: "Rôle d'intermédiaire",
      exclusions_de_garantie: "Exclusions de garantie",
      services_num_riques_: "Services numériques :",
      interruptions_de_service_: "Interruptions de service :",
      donn_es_utilisateur_: "Données utilisateur :",
      usage_frauduleux_: "Usage frauduleux :",
      plafonnement_de_responsabilit_: "Plafonnement de responsabilité",
      montant_de_la_commande: "Montant de la commande",
      plafond_pour_les_services_num_riques: "Plafond pour les services numériques",
      dernier_d_p_t: "Dernier dépôt",
      plafond_pour_les_erreurs_de_traitement: "Plafond pour les erreurs de traitement",
      droit_applicable: "Droit applicable",
      tribunaux_comp_tents: "Tribunaux compétents",
      r_glement_amiable: "Règlement amiable",
      m_diation: "Médiation",
      notification_des_modifications: "Notification des modifications",
      publication_sur_cette_page_avec_indication_de_la_d: "Publication sur cette page avec indication de la date de mise à jour",
      notification_par_email_aux_utilisateurs_actifs: "Notification par email aux utilisateurs actifs",
      affichage_d_un_bandeau_d_information_dans_l_applic: "Affichage d'un bandeau d'information dans l'application",
      entr_e_en_vigueur: "Entrée en vigueur",
      conditions_g_n_rales: "Conditions Générales",
      loi_organique_tunisienne_n_2018_20_du_25_avril_201: "Loi organique tunisienne n° 2018-20 du 25 avril 2018",
      responsable_du_traitement_: "Responsable du traitement :",
      d_l_gu_la_protection_des_donn_es_dpo_: "Délégué à la Protection des Données (DPO) :",
      dans_le_cadre_de_l_utilisation_de_notre_plateforme: "Dans le cadre de l'utilisation de notre plateforme, nous pouvons collecter les catégories de données suivantes :",
      donn_es_d_identification: "Données d'identification",
      nom_et_pr_nom: "Nom et prénom",
      adresse_e_mail: "Adresse e-mail",
      num_ro_de_t_l_phone_mobile_tunisien: "Numéro de téléphone mobile tunisien",
      adresse_de_livraison_pour_les_produits_physiques_: "Adresse de livraison (pour les produits physiques)",
      donn_es_financi_res: "Données financières",
      historique_des_d_p_ts_montant_m_thode_preuve_de_pa: "Historique des dépôts (montant, méthode, preuve de paiement anonymisée)",
      historique_des_commandes_et_d_bits_du_solde_intern: "Historique des commandes et débits du Solde Interne",
      factures_lectroniques: "Factures électroniques",
      donn_es_de_contenu_utilisateur: "Données de contenu utilisateur",
      fichiers_upload_s_pour_la_personnalisation_de_prod: "Fichiers uploadés pour la personnalisation de produits",
      avatar_et_pr_f_rences_de_profil: "Avatar et préférences de profil",
      donn_es_techniques: "Données techniques",
      adresse_ip_et_logs_de_connexion: "Adresse IP et logs de connexion",
      type_d_appareil_navigateur_et_syst_me_d_exploitati: "Type d'appareil, navigateur et système d'exploitation",
      pr_f_rences_langue_mode_sombre_: "Préférences (langue, mode sombre)",
      donn_es_de_navigation_via_cookies: "Données de navigation via cookies",
      le_traitement_de_vos_donn_es_s_effectue_sur_des_ba: "Le traitement de vos données s'effectue sur des bases légales définies par la loi tunisienne :",
      finalit_: "Finalité",
      base_l_gale_loi_2018_20_: "Base Légale (Loi 2018-20)",
      d_tails: "Détails",
      gestion_du_compte_et_du_solde_interne: "Gestion du Compte et du Solde Interne",
      ex_cution_du_contrat_art_13_: "Exécution du contrat (Art. 13)",
      cr_ation_du_portefeuille_eservices_validation_des_: "Création du Portefeuille eServices, validation des dépôts, suivi du solde, authentification",
      traitement_des_commandes: "Traitement des Commandes",
      livraison_des_codes_num_riques_personnalisation_de: "Livraison des codes numériques, personnalisation des produits, facturation, support post-vente",
      archivage_des_preuves_de_paiement: "Archivage des preuves de paiement",
      obligation_l_gale_art_15_: "Obligation légale (Art. 15)",
      conservation_des_justificatifs_financiers_conform_: "Conservation des justificatifs financiers conformément au Code de Commerce tunisien (10 ans)",
      pr_vention_de_la_fraude: "Prévention de la fraude",
      int_r_t_l_gitime_art_14_: "Intérêt légitime (Art. 14)",
      analyse_des_comportements_pour_s_curiser_la_platef: "Analyse des comportements pour sécuriser la plateforme et protéger nos utilisateurs",
      support_client_am_lioration: "Support client & amélioration",
      r_pondre_aux_demandes_via_tickets_am_liorer_l_inte: "Répondre aux demandes via tickets, améliorer l'interface et les services",
      consentement_expr_s_art_12_: "Consentement exprès (Art. 12)",
      uniquement_si_vous_avez_coch_la_case_d_acceptation: "Uniquement si vous avez coché la case d'acceptation lors de l'inscription",
      services_d_envoi_d_e_mails_transactionnels: "Services d'envoi d'e-mails transactionnels",
      prestataires_de_transport: "Prestataires de transport",
      dur_es_de_conservation: "Durées de conservation",
      donn_es_du_compte_actif: "Données du compte actif",
      donn_es_transactionnelles_et_factures: "Données transactionnelles et factures",
      fichiers_upload_s_pour_personnalisation: "Fichiers uploadés pour personnalisation",
      logs_de_s_curit_: "Logs de sécurité",
      proc_dure_de_suppression: "Procédure de suppression",
      anonymis_es: "Anonymisées",
      d_truites_de_mani_re_s_curis_e: "Détruites de manière sécurisée",
      droit_d_acc_s: "Droit d'accès",
      obtenir_la_confirmation_que_vos_donn_es_sont_trait: "Obtenir la confirmation que vos données sont traitées et en recevoir une copie.",
      droit_de_rectification: "Droit de rectification",
      faire_corriger_des_donn_es_inexactes_ou_incompl_te: "Faire corriger des données inexactes ou incomplètes.",
      droit_l_effacement: "Droit à l'effacement",
      demander_la_suppression_de_vos_donn_es_sous_certai: "Demander la suppression de vos données sous certaines conditions.",
      droit_la_limitation: "Droit à la limitation",
      suspension_temporaire_du_traitement_de_vos_donn_es: "Suspension temporaire du traitement de vos données.",
      droit_d_opposition: "Droit d'opposition",
      vous_opposer_au_traitement_pour_des_raisons_l_giti: "Vous opposer au traitement pour des raisons légitimes.",
      droit_la_portabilit_: "Droit à la portabilité",
      recevoir_vos_donn_es_dans_un_format_structur_et_li: "Recevoir vos données dans un format structuré et lisible.",
      comment_exercer_vos_droits_: "Comment exercer vos droits ?",
      mesures_techniques: "Mesures techniques",
      chiffrement_ssl_tls_pour_toutes_les_communications: "Chiffrement SSL/TLS pour toutes les communications",
      pare_feu_et_syst_mes_de_d_tection_d_intrusion: "Pare-feu et systèmes de détection d'intrusion",
      sauvegardes_r_guli_res_et_chiffr_es: "Sauvegardes régulières et chiffrées",
      mots_de_passe_stock_s_sous_forme_hach_e_bcrypt_: "Mots de passe stockés sous forme hachée (bcrypt)",
      authentification_deux_facteurs_pour_l_quipe_admini: "Authentification à deux facteurs pour l'équipe administrative",
      mesures_organisationnelles: "Mesures organisationnelles",
      acc_s_restreint_aux_donn_es_selon_le_principe_du_b: "Accès restreint aux données selon le principe du \"besoin d'en connaître\"",
      formation_obligatoire_du_personnel_la_protection_d: "Formation obligatoire du personnel à la protection des données",
      audits_de_s_curit_r_guliers: "Audits de sécurité réguliers",
      proc_dures_document_es_en_cas_de_violation_de_donn: "Procédures documentées en cas de violation de données",
      notification_en_cas_de_violation: "Notification en cas de violation",
      type_de_cookie: "Type de cookie",
      conservation: "Conservation",
      cookies_essentiels: "Cookies essentiels",
      maintenir_votre_session_de_connexion_g_rer_votre_p: "Maintenir votre session de connexion, gérer votre panier, assurer la sécurité",
      dur_e_de_la_session: "Durée de la session",
      cookies_analytiques: "Cookies analytiques",
      mesurer_l_audience_comprendre_l_usage_de_la_platef: "Mesurer l'audience, comprendre l'usage de la plateforme (anonymisé)",
      m_moriser_votre_langue_mode_sombre_clair: "Mémoriser votre langue, mode sombre/clair",
      clauses_contractuelles_types_de_la_commission_euro: "Clauses contractuelles types de la Commission Européenne",
      certifications_de_protection_des_donn_es_ex_privac: "Certifications de protection des données (ex: Privacy Shield pour les États-Unis, lorsque applicable)",
      accords_de_confidentialit_stricts_avec_nos_sous_tr: "Accords de confidentialité stricts avec nos sous-traitants",
      date_d_entr_e_en_vigueur_: "Date d'entrée en vigueur :",
      email_g_n_ral_: "Email général :",
      probl_me_de_d_p_t: "Problème de dépôt",
      code_non_fonctionnel: "Code non fonctionnel",
      service_interrompu: "Service interrompu",
      conditions_g_n_rales_d_utilisation: "Conditions Générales d'Utilisation",
      note_importante_: "Note importante :",
      article_1_principe_g_n_ral_absence_de_remboursemen: "ARTICLE 1 - PRINCIPE GÉNÉRAL : ABSENCE DE REMBOURSEMENT",
      le_solde_interne_eservices_n_est_pas_remboursable_: "Le Solde Interne eServices n'est pas remboursable.",
      article_2_cas_exceptionnels_de_cr_dit_ou_de_rembou: "ARTICLE 2 - CAS EXCEPTIONNELS DE CRÉDIT OU DE REMBOURSEMENT",
      statut_en_attente_: "Statut \"En attente\" :",
      statut_valid_: "Statut \"Validé\" :",
      exception_pour_double_virement_bancaire_: "Exception pour double virement bancaire :",
      d_lai_: "Délai :",
      v_rification_: "Vérification :",
      article_3_proc_dure_pour_les_cas_exceptionnels_adm: "ARTICLE 3 - PROCÉDURE POUR LES CAS EXCEPTIONNELS ADMIS",
      ouvrez_un_ticket_de_support: "Ouvrez un ticket de support",
      fournissez_toutes_les_preuves_n_cessaires_: "Fournissez toutes les preuves nécessaires :",
      captures_d_cran_compl_tes: "Captures d'écran complètes",
      num_ro_d_identification_de_transaction_d17_flouci_: "Numéro d'identification de transaction (D17/Flouci)",
      justificatifs_de_virement_bancaire: "Justificatifs de virement bancaire",
      num_ro_de_commande_concern_e: "Numéro de commande concernée",
      _tude_de_la_demande_: "Étude de la demande :",
      d_cision_et_compensation_: "Décision et compensation :",
      article_4_frais_applicables: "ARTICLE 4 - FRAIS APPLICABLES",
      sans_frais: "Sans Frais",
      le_traitement_d_une_demande_de_cr_dit_de_remplacem: "Le traitement d'une demande de crédit de remplacement (code défectueux) est gratuit.",
      frais_de_transaction_bancaire: "Frais de Transaction Bancaire",
      article_5_contact_et_modalit_s_de_traitement: "ARTICLE 5 - CONTACT ET MODALITÉS DE TRAITEMENT",
      le_syst_me_de_tickets_garantit_un_suivi_organis_la: "Le système de tickets garantit un suivi organisé, la sécurité des échanges et la possibilité de joindre des pièces justificatives.",
      vous_pouvez_suivre_l_avancement_de_votre_demande_t: "Vous pouvez suivre l'avancement de votre demande à tout moment depuis votre interface.",
      documents_connexes: "Documents connexes",
      politique_de_livraison: "Politique de Livraison",
      date_de_derni_re_mise_jour_: "Date de dernière mise à jour :",
      _diteur: "Éditeur",
      raison_sociale_: "Raison sociale :",
      tva_intracom_: "TVA Intracom :",
      si_ge_social_: "Siège social :",
      contact_l_gal_: "Contact légal :",
      art_1_objet: "Art 1. Objet",
      les_pr_sentes_conditions_g_n_rales_cgu_ont_pour_ob: "Les présentes Conditions Générales (CGU) ont pour objet de définir les droits et obligations des parties dans le cadre de l'utilisation de la plateforme eServices et de son modèle économique basé sur un solde interne prépayé. Elles régissent l'accès au site eservices.tn et à l'application mobile associée, la création du compte Portefeuille eServices, le dépôt de fonds, et l'achat de services numériques et produits personnalisés.",
      art_2_d_finitions: "Art 2. Définitions",
      plateforme_: "Plateforme :",
      utilisateur_client_: "Utilisateur/Client :",
      compte_portefeuille_eservices_: "Compte / Portefeuille eServices :",
      solde_interne_: "Solde Interne :",
      d_p_t_: "Dépôt :",
      commande_: "Commande :",
      art_3_acceptation_et_capacit_: "Art 3. Acceptation et Capacité",
      art_4_description_du_service_et_r_le_de_eservices: "Art 4. Description du Service et Rôle de eServices",
      la_gestion_d_un_portefeuille_lectronique_pr_pay_so: "La gestion d'un portefeuille électronique prépayé (Solde Interne).",
      l_achat_de_services_fournis_par_des_partenaires_ti: "L'achat de Services fournis par des partenaires tiers (opérateurs télécoms, éditeurs de jeux, services de streaming) ou produits par eServices (personnalisation).",
      art_5_cr_ation_et_s_curit_du_compte: "Art 5. Création et Sécurité du Compte",
      art_6_solde_interne_recharge_nature_irr_vocabilit_: "Art 6. Solde Interne : Recharge, Nature, Irrévocabilité",
      la_validation_du_d_p_t_est_conditionn_e_la_r_cepti: "La validation du Dépôt est conditionnée à la réception et vérification manuelle par eServices d'une preuve de paiement valide.",
      le_solde_interne_est_strictement_attach_au_compte_: "Le Solde Interne est strictement attaché au Compte et ne peut être cédé, vendu ou transféré à un tiers.",
      art_7_passation_de_commande_et_paiement: "Art 7. Passation de Commande et Paiement",
      art_8_livraison: "Art 8. Livraison",
      le_droit_de_r_tractation_est_exclu_: "Le droit de rétractation est exclu.",
      livraison_selon_les_modalit_s_indiqu_es_sur_la_fic: "Livraison selon les modalités indiquées sur la fiche produit. Les délais débutent après validation de la personnalisation par notre équipe. Les frais et risques de transport sont précisés au moment de la commande.",
      art_9_droit_de_r_tractation_et_garanties: "Art 9. Droit de Rétractation et Garanties",
      les_services_pleinement_ex_cut_s_avant_la_fin_du_d: "Les services pleinement exécutés avant la fin du délai de rétractation (recharges, codes livrés)",
      les_biens_ou_services_dont_le_prix_d_pend_de_fluct: "Les biens ou services dont le prix dépend de fluctuations des marchés financières",
      les_dispositions_du_code_des_obligations_et_des_co: "Les dispositions du Code des Obligations et des Contrats tunisiens relatives aux vices cachés restent applicables. Pour un code numérique défectueux, le Client doit ouvrir un ticket sous 48h pour obtenir un code de remplacement.",
      art_10_propri_t_intellectuelle: "Art 10. Propriété Intellectuelle",
      la_plateforme_son_design_son_code_source_ses_bases: "La Plateforme, son design, son code source, ses bases de données, ses logos et son contenu éditorial sont la propriété exclusive de eServices ou de ses concédants et sont protégés par le droit d'auteur tunisien et les conventions internationales (INNORPI). Tout fichier uploadé par le Client reste sa propriété intellectuelle ; il en concède une licence d'usage limitée à eServices pour la stricte exécution de la commande.",
      art_11_obligations_et_responsabilit_s_du_client: "Art 11. Obligations et Responsabilités du Client",
      le_client_s_engage_ne_pas_: "Le Client s'engage à ne pas :",
      utiliser_la_plateforme_des_fins_ill_gales_ou_fraud: "Utiliser la Plateforme à des fins illégales ou frauduleuses",
      tenter_de_pirater_d_sassembler_ou_surcharger_l_inf: "Tenter de pirater, désassembler ou surcharger l'infrastructure",
      uploader_des_fichiers_contenant_des_virus_ou_du_co: "Uploader des fichiers contenant des virus ou du contenu illicite",
      contourner_le_syst_me_de_solde_interne: "Contourner le système de solde interne",
      art_12_limitation_de_responsabilit_de_eservices: "Art 12. Limitation de Responsabilité de eServices",
      les_interruptions_dues_la_maintenance_ou_un_cas_de: "Les interruptions dues à la maintenance ou à un cas de force majeure",
      la_perte_de_donn_es_li_e_une_faute_du_client: "La perte de données liée à une faute du Client",
      le_contenu_ou_la_disponibilit_des_services_fournis: "Le contenu ou la disponibilité des services fournis par les partenaires tiers (opérateurs, éditeurs)",
      les_dommages_indirects_perte_de_b_n_fices_perte_d_: "Les dommages indirects (perte de bénéfices, perte d'opportunité)",
      la_responsabilit_de_eservices_si_elle_est_retenue_: "La responsabilité de eServices, si elle est retenue, ne pourra excéder le montant de la commande litigieuse ou du dernier Dépôt effectué.",
      art_13_donn_es_personnelles: "Art 13. Données Personnelles",
      art_14_suspension_et_r_solution: "Art 14. Suspension et Résolution",
      art_16_droit_applicable_et_litiges: "Art 16. Droit Applicable et Litiges",
      tribunaux_de_ville_du_si_ge_social_: "Tribunaux de [Ville du siège social]",
      bient_t_disponible: "Bientôt disponible",
      service_s_curis_et_fiable: "Service sécurisé et fiable",
      support_24_7_disponible: "Support 24/7 disponible",
      google: "Google",
      github: "GitHub",
      services: "Services",
      open_menu: "Open menu",
      close_menu: "Close menu",
      total_payer: "Total à payer",
      entrez_l: "Entrez l",
      r_sum_: "Résumé",
      votre_solde_actuel: "Votre Solde Actuel",
      instructions: "Instructions",
      comptes_bancaires: "Comptes bancaires",
      choisir_un_fichier: "Choisir un fichier",
      aujourd: "Aujourd",
      d_p_ts: "Dépôts",
      total_commandes: "Total Commandes",
      tickets_support: "Tickets Support",
      mes_commandes: "Mes Commandes",
      mes_d_p_ts: "Mes Dépôts",
      commandes_en_attente: "Commandes en attente",
      d_p_ts_en_attente: "Dépôts en attente",
      commandes: "Commandes",
      tickets: "Tickets",
      clients: "Clients",
      produits: "Produits",
      stock: "Stock",
      m_dia: "Média",
      recharger: "Recharger",
      boutique: "Boutique",
      support: "Support",
      historique: "Historique",
      promotion: "Promotion",
      produits_populaires: "Produits Populaires",
      bienvenue_: "Bienvenue,",
      chiffre_d_affaires_total: "Chiffre d'affaires total",
      offre_limit_e: "Offre Limitée",
      netflix_premium_20_: "Netflix Premium -20%",
      profitez_du_meilleur_du_streaming_prix_r_duit_: "Profitez du meilleur du streaming à prix réduit.",
      r_sum_du_jour: "Résumé du Jour",
      aucune_commande_r_cente: "Aucune commande récente",
      mes_favoris: "Mes Favoris",
      retrouvez_les_articles_que_vous_avez_aim_s_: "Retrouvez les articles que vous avez aimés.",
      aucun_favori: "Aucun favori",
      parcourez_le_catalogue_et_ajoutez_des_articles_vos: "Parcourez le catalogue et ajoutez des articles à vos coups de cœur.",
      modifier: "Modifier",
      supprimer: "Supprimer",
      rechercher_: "Rechercher...",
      nom_de_la_cat_gorie: "Nom de la catégorie",
      description_de_la_cat_gorie: "Description de la catégorie",
      preview: "Preview",
      nom_de_la_sous_cat_gorie: "Nom de la sous-catégorie",
      description_de_la_sous_cat_gorie: "Description de la sous-catégorie",
      s_lectionner_une_cat_gorie: "Sélectionner une catégorie",
      preuve_de_d_p_t: "Preuve de dépôt",
      montant: "Montant",
      m_thode: "Méthode",
      preuve_de_paiement: "Preuve de paiement",
      image_non_disponible: "Image non disponible",
      cliquez_pour_voir_le_code_complet: "Cliquez pour voir le code complet",
      aucun_d_p_t: "Aucun dépôt",
      voir_les_d_tails_de_la_commande: "Voir les détails de la commande",
      g_rez_les_commandes_des_clients: "Gérez les commandes des clients",
      montant_total: "Montant total",
      moyen_de_paiement: "Moyen de paiement",
      changer_le_statut_de_la_commande: "Changer le statut de la commande",
      aucune_commande: "Aucune commande",
      client: "Client",
      statut: "Statut",
      articles: "Articles",
      rechercher_un_produit_: "Rechercher un produit...",
      g_rez_votre_catalogue: "Gérez votre catalogue",
      best: "Best",
      aucun_produit_trouv_: "Aucun produit trouvé",
      rechercher_un_client_: "Rechercher un client...",
      g_rez_vos_utilisateurs: "Gérez vos utilisateurs",
      d_p_ts_: "Dépôts:",
      aucun: "Aucun",
      commandes_: "Commandes:",
      aucune: "Aucune",
      conversations_: "Conversations:",
      s_curisation_: "Sécurisation...",
      logo: "Logo",
      saisir_montant: "Saisir montant",
      produit_introuvable: "Produit introuvable",
      prix_de_base: "Prix de base",
      prix_total: "Prix total",
      cat_gorie: "Catégorie",
      sous_cat_gorie: "Sous-catégorie",
      m_thode_de_livraison: "Méthode de livraison",
      moyens_de_paiement: "Moyens de paiement",
      type_de_vente: "Type de vente",
      quantit_minimale: "Quantité minimale",
      s_lectionner_: "Sélectionner...",
      aucune_description_disponible_pour_ce_produit_: "Aucune description disponible pour ce produit.",
      valeur_du_produit: "Valeur du produit",
      s_lectionnez_la_quantit_souhait_e_et_ajoutez_au_pa: "Sélectionnez la quantité souhaitée et ajoutez au panier.",
      proc_dez_au_paiement_s_curis_via_votre_solde_ou_au: "Procédez au paiement sécurisé via votre solde ou autre méthode.",
      recevez_votre_code_instantan_ment_dans_votre_espac: "Recevez votre code instantanément dans votre espace \"Mes Codes\".",
      changement_en_cours_: "Changement en cours...",
      d_sactivation_: "Désactivation...",
      ex_probl_me_de_connexion: "Ex: Problème de connexion",
      d_crivez_votre_probl_me_en_d_tail_: "Décrivez votre problème en détail...",
      tapez_votre_r_ponse_: "Tapez votre réponse...",
      nouveau_ticket: "Nouveau ticket",
      sujet: "Sujet",
      type_d_assistance: "Type d'assistance",
      message: "Message",
      chargement_des_messages_: "Chargement des messages...",
      envoi_: "Envoi...",
      envoyer: "Envoyer",
      rechercher_un_service_: "Rechercher un service...",
      id_de_transaction: "ID de transaction",
      instructions_de_paiement: "Instructions de Paiement",
      ouvrez_l_application_d17_et_envoyez_le_montant: "Ouvrez l'application D17 et envoyez le montant",
      virement_bancaire: "Virement bancaire",
      d_p_ts_ce_mois: "Dépôts ce mois",
      d_penses_ce_mois: "Dépenses ce mois",
      aucun_d_p_t_trouv_: "Aucun dépôt trouvé",
      montant_personnalis_: "Montant personnalisé",
      choisissez_une_m_thode: "Choisissez une méthode",
      page_non_trouv_e: "Page non trouvée",
      produit_introuvable_: "Produit introuvable.",
      total_estim_: "Total estimé",
      jean: "Jean",
      dupont: "Dupont",
      rue_ville_code_postal: "Rue, Ville, Code postal",
      confirmer_le_mot_de_passe: "Confirmer le mot de passe",
      nouveau_mot_de_passe: "Nouveau mot de passe",
      v_rification_du_lien_: "Vérification du lien...",
      mot_de_passe_s_curis_: "Mot de passe sécurisé",
      chiffrement_de_niveau_bancaire: "Chiffrement de niveau bancaire",
      mise_jour_en_cours_: "Mise à jour en cours...",
      mettre_jour_le_mot_de_passe: "Mettre à jour le mot de passe",
      open_sidebar: "Open sidebar",
      open_user_menu: "Open user menu",
      d_connexion: "Déconnexion",
      fermer: "Fermer",
      image_pr_c_dente: "Image précédente",
      image_suivante: "Image suivante",
      aper_u: "Aperçu",
      rechercher_une_image_: "Rechercher une image...",
      biblioth_que_m_dia: "Bibliothèque Média",
      aucune_image_trouv_e: "Aucune image trouvée",
      votre_message_: "Votre message...",
      en_ligne: "En ligne",
      besoin_d_aide_: "Besoin d'aide ?",
      posez_moi_vos_questions_sur_les_recharges_ou_nos_s: "Posez-moi vos questions sur les recharges ou nos services.",
      valeur: "Valeur",
      s_rie_id: "Série / ID",
      date_d_achat: "Date d'achat",
      authentique: "Authentique",
      notifications: "Notifications",
      trustpilot: "Trustpilot",
      retour: "Retour"
    },
    message: {
      failed_to_fetch_admin_stats: "Failed to fetch admin stats",
      failed_to_update_profile: "Failed to update profile",
      failed_to_post_reply: "Failed to post reply",
      failed_to_update_status: "Failed to update status",
      failed_update_meta: "Failed update meta",
      failed_to_fetch_deposits: "Failed to fetch deposits",
      failed_to_update_deposit_status: "Failed to update deposit status",
      failed_to_load_media: "Failed to load media",
      sync_error: "Sync error",
      erreur_lors_de_la_synchronisation_: "Erreur lors de la synchronisation : ",
      upload_error: "Upload error",
      nom_mis_jour: "Nom mis à jour",
      erreur_de_renommage: "Erreur de renommage",
      failed_to_fetch_data: "Failed to fetch data",
      tout_semble_correct_: "Tout semble correct.",
      failed_to_fetch_tickets: "Failed to fetch tickets",
      erreur_lors_de_l: "Erreur lors de l",
      error_loading_product_detail_for_cart: "Error loading product detail for cart",
      failed_to_load_payment_settings: "Failed to load payment settings",
      error_loading_product_detail: "Error loading product detail",
      failed_to_load_services_page_data: "Failed to load services page data",
      failed_to_fetch_dashboard_data_: "Failed to fetch dashboard data:",
      failed_to_load_order_page_data: "Failed to load order page data",
      failed_to_send_reset_email: "Failed to send reset email",
      erreur_turnstile_: "Erreur Turnstile:",
      newsletter_subscription_error: "Newsletter subscription error",
      failed_to_fetch_ticket: "Failed to fetch ticket",
      failed_to_send_reply: "Failed to send reply",
      failed_to_fetch_dashboard_data: "Failed to fetch dashboard data",
      failed_to_fetch_categories_data: "Failed to fetch categories data",
      failed_to_save_category: "Failed to save category",
      failed_to_save_subcategory: "Failed to save subcategory",
      failed_to_delete: "Failed to delete",
      failed_to_fetch_stock_data: "Failed to fetch stock data",
      attempting_to_reveal_code_: "Attempting to reveal code:",
      failed_to_reveal_code_: "Failed to reveal code:",
      failed_to_copy_: "Failed to copy:",
      error_fetching_orders: "Error fetching orders",
      error_fetching_product: "Error fetching product",
      erreur_d: "Erreur d",
      failed_to_fetch_orders_count: "Failed to fetch orders count",
      failed_to_fetch_2fa_status: "Failed to fetch 2FA status",
      failed_to_generate_2fa_secret: "Failed to generate 2FA secret",
      failed_to_verify_2fa_code: "Failed to verify 2FA code",
      failed_to_disable_2fa: "Failed to disable 2FA",
      failed_to_regenerate_recovery_codes: "Failed to regenerate recovery codes",
      failed_to_change_password: "Failed to change password",
      error_fetching_tickets: "Error fetching tickets",
      error_creating_ticket: "Error creating ticket",
      error_fetching_ticket_detail: "Error fetching ticket detail",
      error_posting_reply: "Error posting reply",
      failed_to_fetch_catalog: "Failed to fetch catalog",
      failed_to_fetch_wallet_data: "Failed to fetch wallet data",
      d_p_t_soumis_avec_succ_s_: "Dépôt soumis avec succès !",
      failed_to_submit_deposit: "Failed to submit deposit",
      erreur_lors_de_la_soumission_veuillez_r_essayer_: "Erreur lors de la soumission. Veuillez réessayer.",
      erreur_lors_de_l_: "Erreur lors de l\\",
      erreur_oauth_callback_: "Erreur OAuth callback:",
      error_checking_session: "Error checking session",
      failed_to_reset_password: "Failed to reset password",
      upload_failed: "Upload failed",
      ai_error_: "AI Error:",
      erreur_de_s_curit_impossible_de_r_cup_rer_le_code_: "Erreur de sécurité : Impossible de récupérer le code secret.",
      erreur_lors_de_la_g_n_ration_du_document_pdf_: "Erreur lors de la génération du document PDF.",
      failed_to_fetch_favorite_products_details: "Failed to fetch favorite products details",
      _splashscreen_erreur_lors_de_la_v_rification_ota_: "[SplashScreen] Erreur lors de la vérification OTA:",
      _publiclandingroute_affichage_de_la_landingpage_pu: "[PublicLandingRoute] Affichage de la LandingPage (publique)",
      service_worker_enregistr_avec_succ_s_: "Service Worker enregistré avec succès:",
      _chec_de_l_: "Échec de l\\"
    },
    "Aucune preuve": "Aucune preuve.",
    "Erreur lors de la synchronisation : ": "Erreur lors de la synchronisation : ",
    "Nom mis à jour": "Nom mis à jour",
    "Erreur de renommage": "Erreur de renommage",
    "/": "/",
    "Tracking Number": "Tracking Number",
    "\\n": "\\n",
    "Tout semble correct": "Tout semble correct.",
    nom: "nom",
    statut: "statut",
    solde: "solde",
    date_creation: "date_creation",
    "Erreur lors de l": "Erreur lors de l",
    mobile: {
      nav: {
        home: "Home",
        orders_admin: "Orders",
        support: "Support",
        catalog: "Discover",
        shop: "Shop",
        orders: "Orders",
        favorites: "Favorites",
        profile: "Profile"
      },
      desktop_only: {
        title: "Fonctionnalité Desktop uniquement",
        media: "Médiathèque",
        open_desktop: "Ouvrir sur Desktop"
      }
    },
    sidebar: {
      sections: {
        account: "Compte",
        preferences: "Préférences",
        navigation: "Navigation"
      }
    },
    T: "T",
    ProductCatalog: {
      search: {
        placeholder: "Search for a service..."
      },
      filters: {
        all: "All",
        onSale: "On Sale",
        incoming: "Incoming",
        soldOut: "Sold Out"
      },
      categories: {
        all: "All",
        codes: "Codes",
        licences: "Licenses",
        subscriptions: "Subscriptions",
        recharges: "Recharges"
      },
      product: {
        quickActivation: "Quick activation",
        addToCart: "Add",
        unavailable: "Unavailable"
      },
      empty: {
        noProductsFound: "No products found"
      }
    },
    MobileSupport: {
      header: {
        titleAdmin: "Support Management",
        titleClient: "Need help?",
        subtitleAdmin: "Respond to client requests and manage pending tickets.",
        subtitleClient: "Our technical team is here to support you 24/7.",
        openTicket: "Open a ticket"
      },
      list: {
        sectionTitleAdmin: "All requests",
        sectionTitleClient: "My Requests",
        ticketsCount: "{{count}} tickets",
        emptyAdmin: "No tickets are currently open.",
        emptyClient: "You have no open tickets."
      },
      modal: {
        title: "New ticket",
        subjectLabel: "Subject",
        subjectPlaceholder: "E.g.: Connection issue",
        assistanceTypeLabel: "Type of assistance",
        messageLabel: "Message",
        messagePlaceholder: "Describe your issue in detail...",
        submitButton: "Submit request"
      },
      detail: {
        ticketTitle: "Ticket #{{id}}",
        attachment: "Attachment",
        supportLabel: "eServices Support",
        loadingMessages: "Loading messages..."
      },
      reply: {
        placeholder: "Type your reply...",
        sending: "Sending...",
        send: "Send",
        attachmentOptional: "Attachment (optional)"
      }
    },
    MobileOrders: {
      header: {
        titleAdmin: "Order management",
        titleClient: "Order history",
        subtitleAdmin: "View and manage all client orders.",
        subtitleClient: "Track your purchases in real time."
      },
      card: {
        orderLabel: "Order #{{id}}",
        totalAdmin: "Total amount",
        totalClient: "Total paid"
      },
      item: {
        codeDelivered: "Code delivered",
        accessDelivered: "Access delivered",
        viewAccess: "View access",
        codePending: "Code pending",
        codesCount: "{{count}} codes"
      },
      empty: {
        title: "No orders",
        textAdmin: "No orders have been placed on the store yet.",
        textClient: "You haven't placed any orders on our store yet.",
        discoverCatalog: "Discover the catalog"
      }
    },
    MobileMyCodes: {
      header: {
        title: "My Codes",
        itemsCount: "{{count}} items",
        itemSingular: "1 item"
      },
      alert: {
        deliveryPendingTitle: "Delivery pending",
        deliveryPendingMessage: "Some codes could not be generated automatically. Our administrators will assign them manually.",
        viewOrders: "View my orders"
      },
      loading: "Loading...",
      empty: {
        title: "No codes found",
        subtitle: "Your codes and access will appear here",
        discoverProducts: "Discover products"
      },
      badges: {
        code: "Code",
        licence: "Licence",
        compte: "Account",
        acces: "Access",
        lien: "Link"
      },
      list: {
        refLabel: "REF:",
        cmdLabel: "CMD #"
      },
      fallback: {
        product: "Product"
      },
      drawer: {
        details: "Details",
        close: "Close"
      },
      drawerCode: {
        yourCode: "Your code",
        securing: "Securing...",
        revealSecret: "Reveal secret code",
        copied: "Copied!",
        copy: "Copy",
        hide: "Hide"
      },
      drawerMeta: {
        reference: "Reference",
        order: "Order"
      },
      security: {
        title: "Security guidelines",
        description: "This code or access is strictly confidential. Never share it with third parties."
      },
      errors: {
        codeEmpty: "The code is empty or not found",
        codeRetrieveFail: "Unable to retrieve the code."
      }
    },
    MobileProductDetail: {
      notFound: "Product not found",
      badge: {
        bestSeller: "Best seller"
      },
      valueLabel: "Value: {{value}}",
      reviews: "(4.8 • 124 reviews)",
      price: {
        base: "Base price",
        total: "Total price"
      },
      status: {
        onSale: "On sale",
        incoming: "Incoming",
        soldOut: "Sold out"
      },
      info: {
        title: "Product information",
        category: "Category",
        subCategory: "Subcategory",
        deliveryMethod: "Delivery method",
        paymentMethods: "Payment methods",
        saleType: "Sale type",
        minQuantity: "Minimum quantity"
      },
      deliveryMethods: {
        code_instantane: "Instant code",
        mail_compte_code: "Mail account code",
        mail_code: "Mail code",
        mail_acces: "Mail access",
        mail_licence: "Mail licence",
        traitement_lien: "Link processing",
        livraison_domicile: "Home delivery"
      },
      paymentMethods: {
        solde_interne: "Internal balance",
        flouci: "Flouci",
        d17: "D17",
        virement: "Bank transfer",
        carte_bancaire: "Credit card"
      },
      saleType: {
        detail: "Retail",
        gros: "Wholesale"
      },
      custom: {
        title: "Customization",
        required: "Required",
        selectPlaceholder: "Select...",
        enterField: "Enter your {{field}}",
        amountPlaceholder: "Enter amount",
        fileUploading: "Uploading...",
        fileAdded: "File added",
        addFile: "Add a file"
      },
      features: {
        title: "Included with your choices"
      },
      tabs: {
        description: "Description",
        howItWorks: "How does it work?"
      },
      description: {
        none: "No description available for this product.",
        productValue: "Product value"
      },
      howItWorks: {
        step1: "Select the desired quantity and add to cart.",
        step2: "Proceed to secure payment via your balance or other method.",
        step3: "Receive your code instantly in your \"My Codes\" space."
      },
      actions: {
        outOfStock: "Out of stock",
        addToCart: "Add to cart"
      },
      errors: {
        uploadError: "Upload error."
      }
    },
    VerifyPhone: {
      phone: {
        confirmRegistrationTitle: 'Confirm the number entered during registration',
        confirmRegistrationDescription:
          'A 6-digit code will be sent on WhatsApp to the number below.',
        confirmationLabel: 'Number to confirm',
        verificationTitle: 'Verify your phone number',
        verificationDescription:
          'To secure your account, please confirm your WhatsApp number.',
        whatsappPhoneLabel: 'WhatsApp number',
        whatsappPhonePlaceholder: 'XXXXXXXX',
        phoneFormatHint: 'Expected format: XXXXXXXX (the +216 prefix is applied automatically).',
        sendCodeButton: 'Send code',
        sendCodeSending: 'Sending code...'
      },
      code: {
        enterCodeTitle: 'Enter the received code',
        sentCodeDescription:
          'We sent a 6-digit code on WhatsApp to +{{phone}}.',
        resendCodeIn: 'Resend code in {{countdown}}',
        resendCodeDefault: 'You can resend a new code.',
        resendButton: 'Resend code',
        submitVerifying: 'Verifying...',
        submitButton: 'Confirm code'
      },
      success: {
        registrationSuccessTitle: 'Registration successful',
        phoneVerifiedTitle: 'Phone number verified',
        registrationSuccessDescription:
          'Your account has been created. Sign in with your email and password to access your dashboard.',
        phoneVerifiedDescription:
          'Your WhatsApp number is now linked to your account. You can access your dashboard.',
        registrationSuccessButton: 'Sign in',
        dashboardButton: 'Go to dashboard'
      },
      errors: {
        phoneRequired: 'Please enter your phone number.',
        phoneInvalidLength: 'The number must contain 8 digits (Tunisian local format).',
        phoneInvalid: 'Invalid phone number.',
        finalizationGeneric: 'Error while finalizing registration.',
        linkExpired: 'Link expired. Please restart the registration.',
        codeExpired: 'The code has expired. Please request a new one.',
        tooManyAttempts: 'Too many attempts. Please request a new code later.',
        phoneAlreadyUsed: 'This number is already used by another account. Please choose a different one.',
        emailAlreadyUsed: 'This email is already in use. Sign in or reset your password.',
        invalidCodeServer: 'Invalid code or server error. Please try again.',
        confirmationGeneric: 'Error while verifying the code. Please try again.',
        emailNotFound: 'Account not found for this email. Please restart the registration.',
        invalidCode: 'Invalid code. Please check and try again.'
      }
    },
    legal: {
      documents: {
        subtitle: "Consultez tous nos documents officiels",
        intro: "Retrouvez ici tous nos documents légaux et politiques. Chaque document contient des informations importantes sur nos services, vos droits et nos engagements.",
        info_title: "Besoin d\\",
        info_text: "Si vous avez des questions concernant nos documents légaux, n\\"
      }
    },
    "Erreur lors du chargement des données": "Erreur lors du chargement des données",
    "Le nom de la catégorie est requis": "Le nom de la catégorie est requis",
    "Catégorie modifiée avec succès": "Catégorie modifiée avec succès",
    "Catégorie ajoutée avec succès": "Catégorie ajoutée avec succès",
    "Le nom et la catégorie sont requis": "Le nom et la catégorie sont requis",
    "Sous-catégorie modifiée avec succès": "Sous-catégorie modifiée avec succès",
    "Sous-catégorie ajoutée avec succès": "Sous-catégorie ajoutée avec succès",
    "Erreur lors de la suppression": "Erreur lors de la suppression",
    "La modification doit être effectuée seulement via le Dashboard admin desktop": "La modification doit être effectuée seulement via le Dashboard admin desktop.",
    code_id: "code_id",
    "Erreur d": "Erreur d",
    "Dépôt soumis avec succès !": "Dépôt soumis avec succès !",
    "Erreur lors de la soumission. Veuillez réessayer": "Erreur lors de la soumission. Veuillez réessayer.",
    error: "Une erreur est survenue",
    error_description: "error_description",
    code: "code",
    access_token: "access_token",
    refresh_token: "refresh_token",
    view: "Vue",
    "Erreur de sécurité : Impossible de récupérer le code secret": "Erreur de sécurité : Impossible de récupérer le code secret.",
    "Erreur lors de la génération du document PDF": "Erreur lors de la génération du document PDF.",
    android: {
      app_name: "eServices",
      title_activity_main: "eServices"
    }
  }
};

export { en };
export default en;
